import React, { Component } from 'react';
import { Form, Button, Row, Col, Card, Modal } from 'react-bootstrap';
import Layout from '../Components/Layout';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from 'axios';
import ImageGrid from "../Components/ImageGrid";
import NotesSection from '../Components/NotesSection';
import AuditLogSection from '../Components/AuditLogSection';

const formStyles = `
.searchable-dropdown {
    position: relative;
}
.dropdown-list {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    max-height: 300px;
    overflow-y: auto;
    background: white;
    border: 1px solid #d1d5db;
    border-top: none;
    border-radius: 0 0 6px 6px;
    z-index: 1000;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
}
.dropdown-item-custom {
    padding: 10px 12px;
    cursor: pointer;
    border-bottom: 1px solid #f3f4f6;
    font-size: 14px;
}
.dropdown-item-custom:hover {
    background-color: #f3f4f6;
}
.dropdown-item-custom:last-child {
    border-bottom: none;
}
.no-results {
    padding: 10px 12px;
    text-align: center;
    color: #6b7280;
    font-size: 14px;
}
.form-section {
    background: white;
    border-radius: 12px;
    border: 1px solid #e5e7eb;
    margin-bottom: 20px;
}
.section-header {
    padding: 20px 24px;
    border-bottom: 1px solid #e5e7eb;
    background: #f8f9fa;
    border-radius: 12px 12px 0 0;
}
.section-content {
    padding: 24px;
}
.form-label {
    font-weight: 500;
    color: #374151;
    margin-bottom: 8px;
    font-size: 14px;
}
.form-control, .form-select {
    border: 1px solid #d1d5db;
    border-radius: 6px;
    padding: 10px 12px;
    font-size: 14px;
    width: 100%;
    height: auto;
}
.form-control:focus, .form-select:focus {
    border-color: #3b82f6;
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}
.form-select {
    min-height: calc(1.5em + 20px + 2px);
    background-position: right 12px center;
    background-size: 16px 12px;
}
.accordion {
    border: none !important;
    --bs-accordion-border-width: 0;
    width: 100%;
}
.accordion-item {
    border: 1px solid #e5e7eb !important;
    border-radius: 12px !important;
    margin-bottom: 20px;
    overflow: hidden;
    background: white;
    width: 100%;
}
.accordion-header {
    margin-bottom: 0;
}
.accordion-button {
    background: #f8f9fa !important;
    font-weight: 600;
    color: #374151 !important;
    padding: 20px 24px !important;
    border: none !important;
    box-shadow: none !important;
    position: relative;
    border-radius: 0 !important;
    font-size: 16px;
}
.accordion-button:not(.collapsed) {
    background: #f8f9fa !important;
    color: #374151 !important;
    border-bottom: 1px solid #e5e7eb !important;
    box-shadow: none !important;
}
.accordion-button:focus {
    box-shadow: none !important;
    border-color: #e5e7eb !important;
    z-index: 0;
}
.accordion-button:hover {
    z-index: 0;
}
.accordion-button::after {
    display: none !important;
}
.accordion-button::before {
    content: '▼';
    position: absolute;
    right: 24px;
    top: 50%;
    transform: translateY(-50%);
    transition: transform 0.2s ease;
    font-size: 14px;
    color: #6b7280;
    font-weight: normal;
}
.accordion-button.collapsed::before {
    transform: translateY(-50%) rotate(-90deg);
}
.accordion-body {
    padding: 24px !important;
    border-top: none;
    background: white;
}
.accordion-collapse {
    border-top: 1px solid #e5e7eb;
}
.upload-area {
    border: 2px dashed #d1d5db;
    border-radius: 8px;
    padding: 40px;
    text-align: center;
    background: #f9fafb;
    cursor: pointer;
    transition: all 0.3s;
}
.upload-area:hover {
    border-color: #3b82f6;
    background: #eff6ff;
}
.add-ingredient-btn {
    color: #3b82f6;
    background: none;
    border: none;
    padding: 8px 0;
    font-size: 14px;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    gap: 8px;
}
.add-ingredient-btn:hover {
    text-decoration: underline;
}
.hide-me {
    display:none;
}
`;

export class AddNewRFQ extends Component {
    state = {
        rfqId: null,
        historyId: null,
        tempId: null,
        isEditMode: false,
        showAIExtractionModal: false,
        extractedIngredients: [],
        sfpImages:[],
        newSfpImages:[],
        selectedIngredients: [],
        extractionLoading: false,
        partIdSearchTerms: {}, // Track search terms for each ingredient's Part ID dropdown
        partIdDropdownOpen: {}, // Track which dropdowns are open
        salesReps: [],
        showAllNotes: false,

        // Packaging parts state
        originalPackagingParts: [],
        filteredPackagingParts: [],
        packagingParts: [{
            RfqPackagingPartId: 0,
            RfqId: 0,
            RawsId: 0,
            PartID: '',
            PartName: '',
            IsCsm: 0,
            RfqServingUnitId: 0,
            filteredParts: []
        }],
        showPackagingDropdown: false,
        activePackagingDropdownIndex: null,
        loadingParts: false,
        formData: {
            // Sales Rep
            salesRep: '',

            // Customer Information
            company: '',
            address: '',
            contact: '',
            phone: '',

            // Other Details
            dealType: '',
            targetCompDate: '',
            itemName: '',
            quotePriority: '',
            complexity: '',
            terms: '',
            unitCount: '',

            // Product Information
            productName: '',
            form: 'Select form type',
            orderType: '',
            itemNumber: '',
            sharepointLink: '',
            servingSize: '',
            servingsUnit: [{ RfqServingUnitId: 0, RfqId: 0, ServingUnit: '' }],
            formula: '',

            // Formula Specifications
            formulaSpecsRequested: '',
            ingredients: [{
                partId: '',
                name: '',
                amount: '',
                unit: '',
                PartID: '',
                PartName: '',
                Amount: '',
                Unit: '',
                IsCsm: 0,
                RfqIngredientPartId: 0,
                RfqId: 0,
                deleted: 0,
                Source: 1,
                RawsId: 0,
                AmountPerServing: 0,
                Overage: 100,
                Type: 0,
                OverageCost: 0
            }],

            // Packaging Specifications
            packagingType: '',
            packagingCsm: false,
            bottleType: 'Select bottle type',
            bottleColor: 'Select bottle color',
            closureType: 'Select closure type',
            closureColor: 'Select closure color',
            capLinerType: 'Select cap liner type',
            labelType: 'Select label type',
            cotton: false,
            desiccant: false,
            neckShrink: false,
            productBox: false,
            productInsert: false,
            closureSticker: false,
            masterCase: false,
            sleeve: false,
            hangtag: false,

            // Testing Requirements
            testingReqMicro: false,
            testingReqHeavyMetal: false,
            testingReqAssay: false,
            microTestingIds: [],
            heavyMetalTestingIds: [],
            assayTestingIds: [],
            orderType: false,
            testingRequired: false,
            testInputs: [],
            customTestingRequirement: '',

            // Units Requested - Start with 2 tiers by default
            tiers: [
                { units: '', price: '' },
                { units: '', price: '' }
            ],

            // Additional Information
            allergenFree: false,
            certifiedOrganic: false,
            kitting: false,
            notes: '',

            // Notes Section
            notesList: [],
            currentNote: '',

            // Shipping & Payment Terms
            shippingMethod: 'Select shipping method',
            paymentTerms: ''
        },
        expandedSections: {
            formulaSpecs: true,
            packagingSpecs: false,
            testingReqs: true,
            unitsReq: true,
            additionalInfo: false,
            shippingTerms: false,
            notes: false
        },
        newIngredient: {
            RfqIngredientPartId: 0,
            RfqId: 0,
            PartID: '',
            PartName: '',
            Amount: '',
            Overage: '',
            RawsId: 0,
            AmountPerServing: 0,
            Unit: '',
            Source: 0,
            Type: 0,
            OverageCost: 0,
            IsCsm: 0
        },
        editingIndex: null,
        showDeleteModal: false,
        deleteIngredientIndex: null,
        dropdownOptions: {},
        deleteIngredientName: '',
        loading: false,
        savingDraft: false,
        errors: {},
        isLoading: false,

        // Ingredient parts from raw materials (60000-69999)
        ingredientParts: [],
        loadingParts: false,

        // Searchable dropdown state
        ingredientSearch: '',
        showIngredientDropdown: false,
        filteredIngredients: [],
        customers: [],
        loadingCustomers: false
    }

    componentDidMount() {
        // Load ingredient parts from API
        this.loadIngredientParts();
        // Load packaging parts from API
        this.loadPackagingParts();
        // Load sales reps from API
        this.loadSalesReps();
        // Load customers from API
        this.loadCustomers();
        // Load dropdown options from API
        this.loadDropdownOptions();
        // Check if we're in edit mode by looking for an ID in the URL
        const urlParams = new URLSearchParams(window.location.search);
        const rfqId = urlParams.get('id');
        const historyId = urlParams.get('historyId');
        const tempId = urlParams.get('tempId');

        if (tempId) {
            // Loading from temp data
            this.loadTempRFQData(tempId);
        } else if (rfqId) {
            // Edit mode
            this.setState({ rfqId, isEditMode: true }, () => {
                this.loadRFQData();
            });
        }

        if (historyId) {
            // History mode
            this.setState({ historyId, isEditMode: false }, () => {
                this.loadRFQData();
            });
        }
    }

    hasPackagingData = (formData) => {
        return (
            formData.bottleType !== 'Select bottle type' ||
            formData.bottleColor !== 'Select bottle color' ||
            formData.closureType !== 'Select closure type' ||
            formData.closureColor !== 'Select closure color' ||
            formData.capLinerType !== 'Select cap liner type' ||
            formData.labelType !== 'Select label type' ||
            formData.cotton || formData.desiccant || formData.neckShrink ||
            formData.productBox || formData.productInsert || formData.closureSticker || formData.masterCase
        );
    }

    loadRFQData = async () => {
        try {
            this.setState({ isLoading: true });
            let response;
            let responseData;

            if(this.state.historyId !== null)
            {
                response = await axios.get(`/rfq-history/${this.state.historyId}`);
                responseData = response.data;
            }
            else
            {
                response = await axios.get(`/rfq/${this.state.rfqId}`);
                responseData = response.data;
            }


            if (responseData && responseData.rfq) {
                const rfqData = responseData.rfq;
                const sfpImages = responseData.presignedSfp;

                // Map ingredients data from rfqingredientparts to form format
                const ingredients = responseData.rfqingredientparts ? responseData.rfqingredientparts.map(ingredient => {

                    return {
                        RfqIngredientPartId: ingredient.RfqIngredientPartId,
                        RfqId: ingredient.RfqId,
                        PartID: ingredient.PartID,
                        PartName: ingredient.PartName,
                        Amount: ingredient.Amount,
                        Overage: ingredient.Overage,
                        RawsId: ingredient.RawsId,
                        AmountPerServing: ingredient.AmountPerServing,
                        Unit: ingredient.Unit,
                        Source: ingredient.Source,
                        Type: ingredient.Type,
                        OverageCost: ingredient.OverageCost,
                        IsCsm: ingredient.IsCsm
                    };
                }) : [];

                // Map testing data to form format
                let testInputs = [];
                let testingReqMicro = false;
                let testingReqHeavyMetal = false;
                let testingReqAssay = false;
                let microTestingIds = [];
                let heavyMetalTestingIds = [];
                let assayTestingIds = [];
                let customTestMap = {}; // To deduplicate custom tests by TestName

                if (responseData.testing && responseData.testing.length > 0) {
                    responseData.testing.forEach(test => {
                        // Check if test is one of the predefined testing requirements
                        // For Micro, Heavy Metal, and Assay, we store all IDs for deletion purposes
                        if (test.TestName === 'Micro') {
                            testingReqMicro = true;
                            microTestingIds.push(test.RfqTestingId);
                        } else if (test.TestName === 'Heavy Metal') {
                            testingReqHeavyMetal = true;
                            heavyMetalTestingIds.push(test.RfqTestingId);
                        } else if (test.TestName === 'Assay') {
                            testingReqAssay = true;
                            assayTestingIds.push(test.RfqTestingId);
                        } else {
                            // Add other tests to testInputs, but deduplicate by TestName
                            // Store the first occurrence of each custom test name
                            if (!customTestMap[test.TestName]) {
                                customTestMap[test.TestName] = {
                                    RfqTestingId: test.RfqTestingId || 0,
                                    RfqId: test.RfqId || 0,
                                    TestName: test.TestName,
                                    deleted: test.deleted || 0
                                };
                            }
                        }
                    });

                    // Convert customTestMap to array for testInputs
                    testInputs = Object.values(customTestMap);
                }

                // Map notes data to form format
                let notesList = [];
                if (responseData.notes && responseData.notes.length > 0) {
                    notesList = responseData.notes.map(note => ({
                        RfqNoteId: note.RfqNoteId || 0,
                        RfqId: note.RfqId || 0,
                        NoteText: note.NoteText || '',
                        UserId: note.UserId || 0,
                        CreatedDateTime: note.CreatedDateTime,
                        Username: note.Username || '',
                        Replies: note.Replies ? note.Replies.map(reply => ({
                            RfqNoteReplyId: reply.RfqNoteReplyId || 0,
                            RfqNoteId: reply.RfqNoteId || 0,
                            NoteText: reply.NoteText || '',
                            UserId: reply.UserId || 0,
                            CreatedDateTime: reply.CreatedDateTime,
                            Username: reply.Username || ''
                        })) : []
                    }));
                }

                // Map packaging parts data to form format
                let packagingParts = [{
                    RfqPackagingPartId: 0,
                    RfqId: 0,
                    RawsId: 0,
                    PartID: '',
                    PartName: '',
                    IsCsm: 0,
                    RfqServingUnitId: 0,
                    filteredParts: []
                }];
                if (responseData.packagingParts && responseData.packagingParts.length > 0) {
                    packagingParts = responseData.packagingParts.map(part => ({
                        RfqPackagingPartId: part.RfqPackagingPartId || 0,
                        RfqId: part.RfqId || 0,
                        PartID: part.PartID || '',
                        PartName: part.PartName || '',
                        RawsId: part.RawsId || 0,
                        IsCsm: part.IsCsm || 0,
                        RfqServingUnitId: part.RfqServingUnitId || 0,
                        filteredParts: this.state.originalPackagingParts
                    }));
                }

                // Map tiers data to form format - ensure at least 2 tiers
                let tiers = [
                    { RfqTierId: 0, RfqId: 0, TierNumber: 1, Unit: '', Price: '' },
                    { RfqTierId: 0, RfqId: 0, TierNumber: 2, Unit: '', Price: '' },
                    { RfqTierId: 0, RfqId: 0, TierNumber: 3, Unit: '', Price: '' },
                    { RfqTierId: 0, RfqId: 0, TierNumber: 4, Unit: '', Price: '' },
                    { RfqTierId: 0, RfqId: 0, TierNumber: 5, Unit: '', Price: '' }
                ];
                if (responseData.tiers && responseData.tiers.length > 0) {
                    tiers = responseData.tiers.map(tier => ({
                        Unit: tier.Unit || '',
                        Price: tier.Price ? tier.Price.toString() : '',
                        RfqTierId: tier.RfqTierId,
                        RfqId: tier.RfqId,
                        TierNumber: tier.TierNumber
                    }));
                }

                // Map serving units data to form format - always have at least one field
                let servingUnits = [{ RfqServingUnitId: 0, RfqId: 0, ServingUnit: '' }];
                if (responseData.servingUnits && responseData.servingUnits.length > 0) {
                    servingUnits = responseData.servingUnits.map(unit => ({
                        RfqServingUnitId: unit.RfqServingUnitId || 0,
                        RfqId: unit.RfqId || 0,
                        ServingUnit: unit.ServingUnit || ''
                    }));
                } else if (rfqData.ServingUnit) {
                    // Migrate old single serving unit to new format
                    servingUnits = [{
                        RfqServingUnitId: 0,
                        RfqId: 0,
                        ServingUnit: rfqData.ServingUnit
                    }];
                }

                // Map database fields to form fields
                const formData = {
                    company: rfqData.Company || '',
                    address: rfqData.Address || '',
                    contact: rfqData.Contact || '',
                    phone: rfqData.Phone || '',
                    productName: rfqData.ProductName || '',
                    form: rfqData.Form || 'Select form',
                    servingSize: rfqData.ServingSize || '',
                    servingsUnit: servingUnits,
                    formula: rfqData.Formula || '',
                    formulaSpecsRequested: '',
                    ingredients: ingredients,
                    packagingType: rfqData.PackagingType || '',
                    packagingCsm: rfqData.PackagingCsm === 1 || rfqData.PackagingCsm === true,
                    bottleType: rfqData.BottleType || 'Select bottle type',
                    bottleColor: rfqData.BottleColor || 'Select bottle color',
                    closureType: rfqData.ClosureType || 'Select closure type',
                    closureColor: rfqData.ClosureColor || 'Select closure color',
                    capLinerType: rfqData.CapLinerType || 'Select cap liner type',
                    labelType: rfqData.LabelType || 'Select label type',
                    cotton: rfqData.Cotton || false,
                    desiccant: rfqData.Desiccant || false,
                    neckShrink: rfqData.NeckShrink || false,
                    productBox: rfqData.ProductBox || false,
                    productInsert: rfqData.ProductInsert || false,
                    closureSticker: rfqData.ClosureSticker || false,
                    masterCase: rfqData.MasterCase || false,
                    sleeve: rfqData.Sleeve === true || rfqData.Sleeve === 1 ? true : false,
                    hangtag: rfqData.Hangtag === true || rfqData.Hangtag === 1 ? true : false,
                    testingRequired: rfqData.TestingRequired || false,
                    testInputs: testInputs,
                    tiers: tiers,
                    allergenFree: rfqData.AllergenFree || false,
                    certifiedOrganic: rfqData.CertifiedOrganic || false,
                    kitting: rfqData.Kitting || false,
                    notes: rfqData.AdditionalInformationNotes || '',
                    notesList: notesList,
                    currentNote: '',
                    shippingMethod: rfqData.ShippingMethod || 'Select shipping method',
                    paymentTerms: rfqData.PaymentTerms || '',
                    customClosureColor: rfqData.CustomClosureColor || '',
                    customLabelSpecifications: rfqData.CustomLabelSpecifications || '',
                    customClosureType: rfqData.CustomClosureType || '',
                    customBottleColor: rfqData.CustomBottleColor || '',
                    masterCaseDimensions: rfqData.MasterCaseDimensions || '',
                    countPerCase: rfqData.CountPerCase || '',
                    dielineFileUrl: rfqData.DielineFileUrl?.url || '',
                    dielineFile: rfqData.DielineFile,
                    testingReqMicro: testingReqMicro,
                    testingReqHeavyMetal: testingReqHeavyMetal,
                    testingReqAssay: testingReqAssay,
                    microTestingIds: microTestingIds,
                    heavyMetalTestingIds: heavyMetalTestingIds,
                    assayTestingIds: assayTestingIds,
                    orderType : rfqData.OrderType,
                    itemNumber: rfqData.ItemNumber || '',
                    sharepointLink: rfqData.SharepointLink || '',
                    salesRep:rfqData.SalesRep,
                    dealType: rfqData.DealType || '',
                    targetCompDate: rfqData.TargetCompDate || '',
                    itemName: rfqData.ItemName || '',
                    quotePriority: rfqData.QuotePriority || '',
                    complexity: rfqData.Complexity || '',
                    terms: rfqData.Terms || '',
                    unitCount: rfqData.UnitCount || ''
                };



                // Auto-expand sections that have data
                const expandedSections = {
                    formulaSpecs: ingredients.length > 0,
                    packagingSpecs: this.hasPackagingData(formData),
                    testingReqs: formData.testingReqMicro || formData.testingReqHeavyMetal || formData.testingReqAssay || testInputs.some(test => test.TestName && test.TestName.trim() !== ''),
                    unitsReq: tiers.some(tier => tier.Unit || tier.Price),
                    additionalInfo: formData.allergenFree || formData.certifiedOrganic || formData.kitting || formData.notes,
                    shippingTerms: formData.shippingMethod !== 'Select shipping method' || formData.paymentTerms,
                    notes: notesList.length > 0
                };

                this.setState({
                    formData,
                    expandedSections,
                    sfpImages,
                    packagingParts
                });
            }
        } catch (error) {
            console.error('Error loading RFQ data:', error);
            toast.error('Failed to load RFQ data');
            setTimeout(() => {
                window.location.href = '/request-quote';
            }, 2000);
        } finally {
            this.setState({ isLoading: false });
        }
    }

    loadTempRFQData = async (tempId) => {
        try {
            this.setState({ isLoading: true, tempId: tempId });
            const response = await axios.get(`/rfq-temp/${tempId}`);

            if (response.data && response.data.success) {
                const tempData = response.data.data;

                // Check if temp data has an associated RFQ ID
                let sharepointLink = tempData.sharepointLink || '';

                // If there's an RFQ ID, try to get the SharepointLink from the actual RFQ
                if (tempData.rfqId) {
                    try {
                        const rfqResponse = await axios.get(`/rfq/${tempData.rfqId}`);
                        if (rfqResponse.data && rfqResponse.data.SharepointLink) {
                            // Use SharepointLink from RFQ if it exists
                            sharepointLink = rfqResponse.data.SharepointLink;
                        }
                    } catch (rfqError) {
                        console.warn('Could not fetch RFQ data for SharepointLink:', rfqError);
                        // Continue with temp data sharepointLink
                    }
                }

                // Populate form fields from temp data
                this.setState(prevState => ({
                    formData: {
                        ...prevState.formData,
                        company: tempData.customerName || '',
                        contact: tempData.contactName || '',
                        address: tempData.customerAddress || '',
                        phone: tempData.customerPhone || '',
                        orderType: tempData.orderType || '',
                        itemNumber: tempData.itemNumber || '',
                        sharepointLink: sharepointLink
                    }
                }));

                toast.success('Data loaded from existing formula');
            }
        } catch (error) {
            console.error('Error loading temp RFQ data:', error);
            toast.error('Failed to load temp data');
        } finally {
            this.setState({ isLoading: false });
        }
    }

    handleInputChange = (e) => {
        if (!e || !e.target) {
            console.error('handleInputChange called with invalid event', e);
            return;
        }

        const { name, value, type, checked } = e.target;

        // Validate unitCount to allow only 2 decimal places
        if (name === 'unitCount' && value !== '') {
            const decimalRegex = /^\d*\.?\d{0,2}$/;
            if (!decimalRegex.test(value)) {
                return; // Don't update if invalid format
            }
        }

        const updates = {
            [name]: type === 'checkbox' ? checked : value
        };

        // Reset Master Case fields when unchecked
        if (name === 'masterCase' && !checked) {
            updates.masterCaseDimensions = '';
            updates.countPerCase = '';
        }

        // Reset custom fields when changed from Custom
        if (name === 'bottleColor' && value !== 'Custom') {
            updates.customBottleColor = '';
        }
        if (name === 'closureType' && value !== 'custom') {
            updates.customClosureType = '';
        }
        if (name === 'closureColor' && value !== 'Custom') {
            updates.customClosureColor = '';
        }
        if (name === 'labelType' && value !== 'custom') {
            updates.customLabelSpecifications = '';
            updates.dielineFile = '';
            updates.dielineFileUrl = '';
        }

        this.setState(prevState => ({
            formData: {
                ...prevState.formData,
                ...updates
            }
        }));
    }

    handleServingUnitChange = (index, value) => {
        this.setState(prevState => {
            const updatedServingUnits = [...prevState.formData.servingsUnit];
            const oldServingUnit = updatedServingUnits[index];
            const oldServingUnitId = oldServingUnit.RfqServingUnitId;

            // If this is a new serving unit (RfqServingUnitId === 0), assign a temporary negative ID
            // This ensures each serving unit has a unique identifier even before saving to database
            if (oldServingUnitId === 0 && value && value.trim() !== '') {
                const tempId = -(Date.now() + index); // Negative timestamp-based ID
                updatedServingUnits[index] = {
                    ...updatedServingUnits[index],
                    ServingUnit: value,
                    RfqServingUnitId: tempId
                };

                // Update any existing packaging parts that had the old ID (0)
                let updatedPackagingParts = prevState.packagingParts.map(part => {
                    if (part.RfqServingUnitId === oldServingUnitId) {
                        // Only update if this is the first part that matches
                        const partsWithSameId = prevState.packagingParts.filter(p => p.RfqServingUnitId === oldServingUnitId);
                        if (partsWithSameId.length === 1 || part === partsWithSameId[0]) {
                            return { ...part, RfqServingUnitId: tempId };
                        }
                    }
                    return part;
                });

                // Check if we need to add a default packaging part
                const hasPackagingPart = updatedPackagingParts.some(p =>
                    p.RfqServingUnitId === tempId && !p.deleted
                );

                if (!hasPackagingPart) {
                    const newPart = {
                        RfqPackagingPartId: 0,
                        RfqId: 0,
                        RawsId: 0,
                        PartID: '',
                        PartName: '',
                        IsCsm: 0,
                        RfqServingUnitId: tempId,
                        filteredParts: prevState.originalPackagingParts
                    };
                    updatedPackagingParts.push(newPart);
                }

                return {
                    formData: {
                        ...prevState.formData,
                        servingsUnit: updatedServingUnits
                    },
                    packagingParts: updatedPackagingParts
                };
            } else {
                // Existing serving unit, just update the value
                updatedServingUnits[index] = {
                    ...updatedServingUnits[index],
                    ServingUnit: value
                };

                // If this serving unit now has a value and doesn't have a default packaging part, add one
                let updatedPackagingParts = [...prevState.packagingParts];
                if (value && value.trim() !== '') {
                    const hasPackagingPart = updatedPackagingParts.some(p =>
                        p.RfqServingUnitId === oldServingUnitId && !p.deleted
                    );

                    if (!hasPackagingPart) {
                        const newPart = {
                            RfqPackagingPartId: 0,
                            RfqId: 0,
                            RawsId: 0,
                            PartID: '',
                            PartName: '',
                            IsCsm: 0,
                            RfqServingUnitId: oldServingUnitId,
                            filteredParts: prevState.originalPackagingParts
                        };
                        updatedPackagingParts.push(newPart);
                    }
                }

                return {
                    formData: {
                        ...prevState.formData,
                        servingsUnit: updatedServingUnits
                    },
                    packagingParts: updatedPackagingParts
                };
            }
        });
    }

    addServingUnit = () => {
        this.setState(prevState => ({
            formData: {
                ...prevState.formData,
                servingsUnit: [
                    ...prevState.formData.servingsUnit,
                    { RfqServingUnitId: 0, RfqId: 0, ServingUnit: '' }
                ]
            }
        }));
    }

    removeServingUnit = (index) => {
        this.setState(prevState => {
            const updatedServingUnits = [...prevState.formData.servingsUnit];
            const activeUnits = updatedServingUnits.filter(unit => !unit.deleted);

            // Keep at least one serving unit field
            if (activeUnits.length <= 1) {
                return prevState;
            }

            const unitToRemove = updatedServingUnits[index];

            // If it's an existing record (has an ID), mark as deleted
            if (unitToRemove.RfqServingUnitId && unitToRemove.RfqServingUnitId > 0) {
                updatedServingUnits[index] = { ...unitToRemove, deleted: 1 };
            } else {
                // If it's a new record (no ID), just remove from array
                updatedServingUnits.splice(index, 1);
            }

            return {
                formData: {
                    ...prevState.formData,
                    servingsUnit: updatedServingUnits
                }
            };
        });
    }

    handleDielineFileChange = async (e) => {
        if (!e || !e.target) {
            console.error('handleDielineFileChange called with invalid event', e);
            return;
        }

        const files = e.target.files;
        if (files && files.length > 0) {
            const file = files[0];
            await this.uploadDielineFile(file);
        }
    }

    uploadDielineFile = async (file) => {
        try {
            const formData = new FormData();
            formData.append('file', file);

            if (this.state.rfqId) {
                formData.append('rfq_id', this.state.rfqId);
            }

            const response = await axios.post('/rfq/upload-dieline', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });

            if (response.data.success) {
                this.setState(prevState => ({
                    formData: {
                        ...prevState.formData,
                        dielineFile: response.data.fileName,
                        dielineFileUrl: response.data.presigned?.url || response.data.presigned,
                        dielineFileId: response.data.fileId
                    }
                }));
                toast.success('File uploaded successfully!');
            }
        } catch (error) {
            console.error('Error uploading file:', error);
            toast.error('Failed to upload file');
        }
    }

    loadSalesReps = () => {
        axios.get('sales-reps')
            .then(response => {
                const salesReps = response.data.data || [];
                this.setState({ salesReps });
            })
            .catch(error => {
                console.error('Error loading sales reps:', error);
                this.setState({ salesReps: [] });
            });
    }

    loadDropdownOptions = () => {
        axios.get('/dropdowns')
            .then(response => {
                this.setState({ dropdownOptions: response.data });
            })
            .catch(error => {
                console.error('Error loading dropdown options:', error);
            });
    }

    loadCustomers = () => {
        this.setState({ loadingCustomers: true });
        axios.get('customer-list-databricks')
            .then(response => {
                const customers = response.data.data || [];
                this.setState({ customers, loadingCustomers: false });
            })
            .catch(error => {
                console.error('Error loading customers:', error);
                this.setState({ customers: [], loadingCustomers: false });
            });
    }

    handleCustomerChange = (e) => {
        const selectedCustomerName = e.target.value;
        const selectedCustomer = this.state.customers.find(
            customer => customer.customer_name === selectedCustomerName
        );

        if (selectedCustomer) {
            this.setState(prevState => ({
                formData: {
                    ...prevState.formData,
                    company: selectedCustomer.customer_name || '',
                    address: selectedCustomer.address || '',
                    contact: selectedCustomer.contact_name || '',
                    phone: selectedCustomer.phone_number || ''
                }
            }));
        } else {
            // If empty selection, clear the fields
            this.setState(prevState => ({
                formData: {
                    ...prevState.formData,
                    company: '',
                    address: '',
                    contact: '',
                    phone: ''
                }
            }));
        }
    }

    loadIngredientParts = () => {
        this.setState({ loadingParts: true });


        axios.put('raws/get-raws-by-ingredient')
            .then(response => {
                const ingredientParts = response.data.records || [];

                // Transform the raw materials data - use Id and RawMaterialName
                const transformedParts = ingredientParts.map(part => ({
                    id: part.Id,
                    name: part.RawMaterialName,
                    rawsId: part.RawsId
                }));

                this.setState({
                    ingredientParts: transformedParts,
                    filteredIngredients: transformedParts,
                    loadingParts: false
                });
            })
            .catch(error => {
                console.error('Error loading ingredient parts:', error);
                this.setState({
                    ingredientParts: [],
                    loadingParts: false
                });
            });
    }

    loadPackagingParts = () => {
        axios.put('raws/get-raws-by-packaging')
            .then(response => {
                const packagingParts = response.data.records || [];

                const transformedParts = packagingParts.map(part => ({
                    id: part.Id,
                    name: part.RawMaterialName,
                    rawsId: part.RawsId
                }));

                const updatedPackagingParts = this.state.packagingParts.map(part => ({
                    ...part,
                    filteredParts: transformedParts
                }));

                this.setState({
                    originalPackagingParts: transformedParts,
                    filteredPackagingParts: transformedParts,
                    packagingParts: updatedPackagingParts
                });
            })
            .catch(error => {
                console.error('Error loading packaging parts:', error);
                this.setState({
                    originalPackagingParts: [],
                    filteredPackagingParts: []
                });
            });
    }

    handlePackagingSearch = (searchValue, index) => {
        const filtered = this.state.originalPackagingParts.filter(part =>
            part.name.toLowerCase().includes(searchValue.toLowerCase()) ||
            (part.id && part.id.toString().includes(searchValue))
        );

        const updatedParts = [...this.state.packagingParts];
        updatedParts[index].PartName = searchValue;

        this.setState({
            packagingParts: updatedParts,
            filteredPackagingParts: filtered,
            showPackagingDropdown: true,
            activePackagingDropdownIndex: index
        });
    }

    selectPackagingPart = (packagingPart, index) => {
        const updatedParts = [...this.state.packagingParts];
        const currentServingUnitId = updatedParts[index].RfqServingUnitId;

        // Only check for duplicates within the same serving unit section
        const isDuplicate = updatedParts.some((part, idx) =>
            idx !== index &&
            part.PartID === packagingPart.id &&
            part.RfqServingUnitId === currentServingUnitId
        );

        if (isDuplicate) {
            toast.error(`Part ID "${packagingPart.id}" is already added in this section. Please select a different part.`);
            this.setState({
                showPackagingDropdown: false,
                activePackagingDropdownIndex: null
            });
            return;
        }

        updatedParts[index].PartID = packagingPart.id;
        updatedParts[index].PartName = packagingPart.name;
        updatedParts[index].RawsId = packagingPart.rawsId;

        this.setState({
            packagingParts: updatedParts,
            showPackagingDropdown: false,
            activePackagingDropdownIndex: null
        });
    }

    handlePackagingInputFocus = (index) => {
        this.setState({
            showPackagingDropdown: true,
            filteredPackagingParts: this.state.originalPackagingParts,
            activePackagingDropdownIndex: index
        });
    }

    handlePackagingInputBlur = () => {
        setTimeout(() => {
            this.setState({
                showPackagingDropdown: false,
                activePackagingDropdownIndex: null
            });
        }, 200);
    }

    addPackagingPart = (servingUnitId = 0) => {
        const newPart = {
            RfqPackagingPartId: 0,
            RfqId: 0,
            RawsId: 0,
            PartID: '',
            PartName: '',
            IsCsm: 0,
            RfqServingUnitId: servingUnitId,
            filteredParts: this.state.originalPackagingParts
        };

        this.setState({
            packagingParts: [...this.state.packagingParts, newPart]
        });
    }

    togglePackagingCSM = (index) => {
        const updatedParts = [...this.state.packagingParts];
        updatedParts[index].IsCsm = updatedParts[index].IsCsm ? 0 : 1;
        this.setState({ packagingParts: updatedParts });
    }

    removePackagingPart = (index) => {
        if (this.state.packagingParts.length > 1) {
            const updatedParts = [...this.state.packagingParts];
            updatedParts[index] = {
                ...updatedParts[index],
                deleted: true
            };
            this.setState({ packagingParts: updatedParts });
        }
    }

    handlePartIdChange = (index, value, type) => {
        if (type === 'packaging') {
            const updatedParts = [...this.state.packagingParts];
            const currentServingUnitId = updatedParts[index].RfqServingUnitId;

            if (value.trim()) {
                // Only check for duplicates within the same serving unit section
                const isDuplicate = updatedParts.some((part, idx) =>
                    idx !== index &&
                    part.PartID === value &&
                    part.RfqServingUnitId === currentServingUnitId
                );

                if (isDuplicate) {
                    toast.error(`Part ID "${value}" is already added in this section. Please select a different part.`);
                    return;
                }
            }

            updatedParts[index].PartID = value;

            const baseParts = this.state.originalPackagingParts;
            const matchingPart = baseParts.find(part => part.id === value);

            if (matchingPart) {
                updatedParts[index].PartName = matchingPart.name;
                updatedParts[index].RawsId = matchingPart.rawsId || 0;
            } else {
                updatedParts[index].PartName = '';
                updatedParts[index].RawsId = 0;
            }

            if (!value.trim()) {
                updatedParts[index].filteredParts = baseParts;
            } else {
                updatedParts[index].filteredParts = baseParts.filter(part =>
                    part.id.toLowerCase().includes(value.toLowerCase())
                );
            }

            this.setState({ packagingParts: updatedParts });
        }
    }

    toggleSection = (sectionName) => {
        this.setState(prevState => ({
            expandedSections: {
                ...prevState.expandedSections,
                [sectionName]: !prevState.expandedSections[sectionName]
            }
        }));
    }

    handleNewIngredientChange = (field, value) => {
        // If Part ID is changed, try to find and auto-populate the ingredient name

        if (field === 'PartID' && value) {
            const matchingIngredient = this.state.ingredientParts.find(part =>
                part.id && part.id.toString() === value.toString()
            );



            if (matchingIngredient) {
                this.setState(prevState => ({
                    newIngredient: {
                        ...prevState.newIngredient,
                        PartID: value,
                        PartName: matchingIngredient.name,
                        RawsId: matchingIngredient.rawsId
                    },
                    ingredientSearch: matchingIngredient.name
                }));
                return;
            }
        }

        this.setState(prevState => ({
            newIngredient: {
                ...prevState.newIngredient,
                [field]: value
            }
        }));
    }

    handleIngredientSearch = (searchValue) => {
        const filtered = this.state.ingredientParts.filter(part =>
            part.name.toLowerCase().includes(searchValue.toLowerCase()) ||
            (part.id && part.id.toString().includes(searchValue))
        );

        this.setState({
            ingredientSearch: searchValue,
            filteredIngredients: filtered,
            showIngredientDropdown: true
        });
    }

    selectIngredient = (ingredient) => {
        this.setState(prevState => ({
            newIngredient: {
                ...prevState.newIngredient,
                PartID: ingredient.id,
                PartName: ingredient.name,
                RawsId: ingredient.rawsId
            },
            ingredientSearch: ingredient.name,
            showIngredientDropdown: false
        }));
    }

    handleIngredientInputFocus = () => {
        this.setState({
            showIngredientDropdown: true,
            filteredIngredients: this.state.ingredientParts
        });
    }

    handleIngredientInputBlur = () => {
        // Delay to allow click on dropdown item
        setTimeout(() => {
            this.setState({ showIngredientDropdown: false });
        }, 200);
    }

    handleAddIngredient = () => {
        const { newIngredient, editingIndex, formData, ingredientSearch } = this.state;

        console.log('edited index');
        console.log(editingIndex);
        console.log(newIngredient);
        console.log('edited index');

        // Use ingredientSearch for the name if newIngredient.name is empty
        const ingredientName = newIngredient.PartName || ingredientSearch;

        if (!ingredientName || !ingredientName.trim()) {
            toast.error('Please select an ingredient name');
            return;
        }

        // Validate that an ingredient was selected from the dropdown (has partId)
        if (!newIngredient.PartID) {
            toast.error('Please select an ingredient from the dropdown list');
            return;
        }

        // Check for duplicate ingredients (case-insensitive comparison)
        const isDuplicate = formData.ingredients.some(existing =>
            existing.PartName.toLowerCase().trim() === ingredientName.toLowerCase().trim() &&
            existing.Amount === newIngredient.Amount &&
            existing.Unit.toLowerCase().trim() === newIngredient.Unit.toLowerCase().trim()
        );

        if (isDuplicate && editingIndex === null) {
            toast.warning('This ingredient with the same name, amount, and unit already exists!');
            return;
        }

        const ingredientToAdd = {
            RfqIngredientPartId:newIngredient.RfqIngredientPartId,
            RfqId:newIngredient.RfqId,
            PartID: newIngredient.PartID,
            PartName: ingredientName,
            Amount: newIngredient.Amount,
            Overage: newIngredient.Overage,
            RawsId: newIngredient.RawsId,
            AmountPerServing: newIngredient.AmountPerServing,
            Unit: newIngredient.Unit,
            Source: editingIndex !== null ? newIngredient.Source : 1,
            Type: newIngredient.Type,
            OverageCost: newIngredient.OverageCost,
            IsCsm: newIngredient.IsCsm,
        };

        this.setState(prevState => ({
            formData: {
                ...prevState.formData,
                ingredients: [...prevState.formData.ingredients, ingredientToAdd]
            },
            newIngredient: {
                RfqIngredientPartId: 0,
                RfqId: 0,
                PartID: '',
                PartName: '',
                Amount: '',
                Overage: '',
                RawsId: 0,
                AmountPerServing: 0,
                Unit: '',
                Source: 0,
                Type: 0,
                OverageCost: 0,
                IsCsm: 0
            },
            ingredientSearch: '',
            editingIndex: null
        }));

        const message = editingIndex !== null ? 'Ingredient updated successfully' : 'Ingredient added successfully';
        toast.success(message);
    }

    handleEditIngredient = (index) => {
        const ingredient = this.state.formData.ingredients[index];
        console.log('editing index');
        console.log(index);
        console.log('editing index');
        // Pre-populate the form with the ingredient data for editing
        this.setState({
            newIngredient: {
                RfqIngredientPartId: ingredient.RfqIngredientPartId,
                RfqId: ingredient.RfqId,
                PartID: ingredient.PartID,
                PartName: ingredient.PartName,
                Amount: ingredient.Amount,
                Overage: ingredient.Overage,
                RawsId: ingredient.RawsId,
                AmountPerServing: ingredient.AmountPerServing,
                Unit: ingredient.Unit,
                Source: ingredient.Source,
                Type: ingredient.Type,
                OverageCost: ingredient.OverageCost,
                IsCsm: ingredient.IsCsm
            },
            ingredientSearch: ingredient.PartName,
            editingIndex: index
        });

        // Remove the ingredient from the list temporarily (without confirmation)
        const updatedIngredients = this.state.formData.ingredients.filter((_, i) => i !== index);
        this.setState(prevState => ({
            formData: {
                ...prevState.formData,
                ingredients: updatedIngredients
            }
        }));

        toast.info('Ingredient loaded for editing');
    }

    toggleIngredientCSM = (index) => {
        const updatedIngredients = [...this.state.formData.ingredients];
        updatedIngredients[index].IsCsm = updatedIngredients[index].IsCsm ? 0 : 1;
        this.setState(prevState => ({
            formData: {
                ...prevState.formData,
                ingredients: updatedIngredients
            }
        }));
    }

    handleIngredientChange = (index, field, value) => {

        const updatedIngredients = [...this.state.formData.ingredients];
        updatedIngredients[index][field] = value;

        this.setState(prevState => ({
            formData: {
                ...prevState.formData,
                ingredients: updatedIngredients
            }
        }));
    }

    handleRemoveIngredient = (index) => {
        const ingredient = this.state.formData.ingredients[index];

        if (ingredient) {
            this.setState({
                showDeleteModal: true,
                deleteIngredientIndex: index,
                deleteIngredientName: ingredient.PartName
            });
        }
    }

    confirmDeleteIngredient = async () => {
        const { deleteIngredientIndex } = this.state;
        
        const updatedParts = [...this.state.formData.ingredients];
        updatedParts[deleteIngredientIndex] = {
                ...updatedParts[deleteIngredientIndex],
                deleted: 1
            };
        

        this.setState(prevState => ({
            formData: {
                ...prevState.formData,
                ingredients: updatedParts
            },
            showDeleteModal: false,
            deleteIngredientIndex: null,
            deleteIngredientName: ''
        }));

        toast.success('Ingredient deleted successfully');
    }

    cancelDeleteIngredient = () => {
        this.setState({
            showDeleteModal: false,
            deleteIngredientIndex: null,
            deleteIngredientName: ''
        });
    }

    // New inline ingredient handlers
    addIngredient = () => {
        this.setState(prevState => ({
            formData: {
                ...prevState.formData,
                ingredients: [
                    ...prevState.formData.ingredients,
                    {
                        partId: '',
                        name: '',
                        amount: '',
                        unit: '',
                        PartID: '',
                        PartName: '',
                        Amount: '',
                        Unit: '',
                        IsCsm: 0,
                        RfqIngredientPartId: 0,
                        RfqId: 0,
                        deleted: 0,
                        Source: 1,
                        RawsId: 0,
                        AmountPerServing: 0,
                        Overage: 100,
                        Type: 0,
                        OverageCost: 0
                    }
                ]
            }
        }));
    }

    handleIngredientPartIdChange = (index, value) => {
        const updatedIngredients = [...this.state.formData.ingredients];
        updatedIngredients[index].partId = value;

        // Try to find and auto-populate the ingredient name
        if (value) {
            const matchingPart = this.state.ingredientParts.find(part => part.id.toString() === value);
            if (matchingPart) {
                updatedIngredients[index].name = matchingPart.name;
                updatedIngredients[index].partId = matchingPart.id;
                updatedIngredients[index].PartID = matchingPart.id;
                updatedIngredients[index].PartName = matchingPart.name;
                updatedIngredients[index].RawsId = matchingPart.rawsId || 0;
            }
        }

        this.setState(prevState => ({
            formData: {
                ...prevState.formData,
                ingredients: updatedIngredients
            }
        }));
    }

    handleIngredientNameSearch = (searchValue, index) => {
        const updatedIngredients = [...this.state.formData.ingredients];
        updatedIngredients[index].name = searchValue;

        const filtered = this.state.ingredientParts.filter(part =>
            part.name.toLowerCase().includes(searchValue.toLowerCase()) ||
            (part.id && part.id.toString().includes(searchValue))
        );

        this.setState(prevState => ({
            formData: {
                ...prevState.formData,
                ingredients: updatedIngredients
            },
            filteredIngredients: filtered,
            showIngredientDropdown: true,
            activeDropdownIndex: index
        }));
    }

    handleIngredientRowFocus = (index) => {
        this.setState({
            showIngredientDropdown: true,
            filteredIngredients: this.state.ingredientParts,
            activeDropdownIndex: index
        });
    }

    selectIngredientForRow = (ingredient, index) => {
        const updatedIngredients = [...this.state.formData.ingredients];
        updatedIngredients[index] = {
            ...updatedIngredients[index],
            partId: ingredient.id,
            name: ingredient.name,
            PartID: ingredient.id,
            PartName: ingredient.name,
            RawsId: ingredient.rawsId || 0
        };

        this.setState(prevState => ({
            formData: {
                ...prevState.formData,
                ingredients: updatedIngredients
            },
            showIngredientDropdown: false,
            activeDropdownIndex: null
        }));

        setTimeout(() => {
            this.setState({
                filteredIngredients: this.state.ingredientParts
            });
        }, 200);
    }

    handleIngredientFieldChange = (index, field, value) => {
        const updatedIngredients = [...this.state.formData.ingredients];
        updatedIngredients[index][field] = value;

        // Also update capitalized fields for backend compatibility
        if (field === 'amount') {
            updatedIngredients[index].Amount = value;
        } else if (field === 'unit') {
            updatedIngredients[index].Unit = value;
        } else if (field === 'partId') {
            updatedIngredients[index].PartID = value;
        } else if (field === 'name') {
            updatedIngredients[index].PartName = value;
        }

        this.setState(prevState => ({
            formData: {
                ...prevState.formData,
                ingredients: updatedIngredients
            }
        }));
    }

    removeIngredient = (index) => {
        const ingredient = this.state.formData.ingredients[index];

        if (ingredient.RfqIngredientPartId && ingredient.RfqIngredientPartId > 0) {
            // Mark as deleted if it exists in the database
            const updatedIngredients = [...this.state.formData.ingredients];
            updatedIngredients[index] = {
                ...updatedIngredients[index],
                deleted: 1
            };

            this.setState(prevState => ({
                formData: {
                    ...prevState.formData,
                    ingredients: updatedIngredients
                }
            }));
        } else {
            // Remove from array if it's new
            const updatedIngredients = this.state.formData.ingredients.filter((_, i) => i !== index);
            this.setState(prevState => ({
                formData: {
                    ...prevState.formData,
                    ingredients: updatedIngredients
                }
            }));
        }

        toast.success('Ingredient removed');
    }

    handleTierChange = (index, field, value) => {
        const updatedTiers = [...this.state.formData.tiers];
        console.log(updatedTiers);
        console.log(index);
        console.log(field);
        console.log(value);
        updatedTiers[index][field] = value;

        this.setState(prevState => ({
            formData: {
                ...prevState.formData,
                tiers: updatedTiers
            }
        }));
    }

    handleAddTier = () => {
        const { tiers } = this.state.formData;

        // Check if all existing tiers have both units and price filled
        for (let i = 0; i < tiers.length; i++) {
            if (!tiers[i].Unit) {
                toast.error(`Please fill in Qty ${i + 1} units and target price before adding another tier`);
                return;
            }
        }

        this.setState(prevState => ({
            formData: {
                ...prevState.formData,
                tiers: [...prevState.formData.tiers, { Unit: '', Price: '', TierNumber: tiers.length + 1,RfqId: 0, RfqTierId:0 }]
            }
        }));

        toast.success(`Qty ${tiers.length + 1} added`);
    }

    handleRemoveTier = async (index) => {

        const updatedTiers = [...this.state.formData.tiers];
		updatedTiers[index] = {
				...updatedTiers[index],
				deleted: 1
			};



        this.setState(prevState => ({
            formData: {
                ...prevState.formData,
                tiers: updatedTiers
            }
        }));

    }

    handleFileUpload = async (e) => {
        const file = e.target.files[0];
        if (file) {
            // Validate file type
            const validTypes = ['image/jpeg', 'image/jpg', 'image/png', 'application/pdf'];
            if (!validTypes.includes(file.type)) {
                toast.error('Please upload a valid image (JPG, PNG) or PDF file');
                return;
            }

            // Check file size (max 10MB)
            const maxSize = 10 * 1024 * 1024; // 10MB
            if (file.size > maxSize) {
                toast.error('File size must be less than 10MB');
                return;
            }

            this.setState({ extractionLoading: true });
            toast.info(`Processing ${file.name}...`);

            try {
                const formData = new FormData();
                const rfqId = (this.state.rfqId === null || this.state.rfqId === undefined || this.state.rfqId === "") ? 0 : this.state.rfqId;
                formData.append('file', file);
                formData.append('rfqId', rfqId);

                const response = await axios.post('/extract-ingredients', formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                });

                if (response.data.success && response.data.ingredients) {
                    const ingredients = response.data.ingredients;
                    const presignedSfp = response.data.presignedSfp;

                    // Map extracted ingredients to match with existing parts
                    const mappedIngredients = ingredients.map((ing, index) => ({
                        ...ing,
                        id: `ai_${index}`,
                        selected: true,
                        partId: '',
                        rawsId: 0,
                        matched: false
                    }));
                    // Try to auto-match with existing ingredient parts
                    mappedIngredients.forEach(ing => {
                        const matchedPart = this.state.ingredientParts.find(part =>
                            part.name.toLowerCase().includes(ing.name.toLowerCase()) ||
                            ing.name.toLowerCase().includes(part.name.toLowerCase())
                        );
                        if (matchedPart !== undefined) {
                            ing.partId = matchedPart.id;
                            ing.rawsId = matchedPart.rawsId;
                            ing.matched = true;
                            ing.matchedName = matchedPart.name;
                        }
                    });

                    let sfpImages = this.state.sfpImages;
                    sfpImages = [];
                    sfpImages.push(presignedSfp)
                    let newSfpImages = this.state.newSfpImages;
                    if(rfqId == 0)
                    {
                        newSfpImages.push(response.data.rfqsfpModel)
                    }

                    this.setState({
                        extractedIngredients: mappedIngredients,
                        selectedIngredients: mappedIngredients.map(ing => ing.id),
                        showAIExtractionModal: true,
                        extractionLoading: false,
                        sfpImages: sfpImages,
                        newSfpImages: newSfpImages
                    });

                    toast.success(`Successfully extracted ${ingredients.length} ingredients`);
                } else {
                    toast.error('No ingredients could be extracted from the image');
                    this.setState({ extractionLoading: false });
                }
            } catch (error) {
                console.error('Error extracting ingredients:', error);
                toast.error('Failed to extract ingredients. Please try again.');
                this.setState({ extractionLoading: false });
            }
        }

        // Reset file input
        e.target.value = null;
    }

    toggleIngredientSelection = (ingredientId) => {
        this.setState(prevState => {
            const selectedIngredients = prevState.selectedIngredients.includes(ingredientId)
                ? prevState.selectedIngredients.filter(id => id !== ingredientId)
                : [...prevState.selectedIngredients, ingredientId];

            // Update the selected state in extractedIngredients
            const extractedIngredients = prevState.extractedIngredients.map(ing => ({
                ...ing,
                selected: selectedIngredients.includes(ing.id)
            }));

            return { selectedIngredients, extractedIngredients };
        });
    }

    selectAllIngredients = () => {
        const allIds = this.state.extractedIngredients.map(ing => ing.id);
        this.setState({
            selectedIngredients: allIds,
            extractedIngredients: this.state.extractedIngredients.map(ing => ({ ...ing, selected: true }))
        });
    }

    deselectAllIngredients = () => {
        this.setState({
            selectedIngredients: [],
            extractedIngredients: this.state.extractedIngredients.map(ing => ({ ...ing, selected: false }))
        });
    }

    updateExtractedIngredient = (ingredientId, field, value) => {
        this.setState(prevState => {
            const extractedIngredients = prevState.extractedIngredients.map(ing => {
                if (ing.id === ingredientId) {
                    const updated = { ...ing, [field]: value };

                    // If updating partId, also update matched status
                    if (field === 'partId') {
                        const matchedPart = this.state.ingredientParts.find(part => part.id === value);
                        if (matchedPart) {
                            updated.rawsId = matchedPart.rawsId;
                            updated.matched = true;
                            updated.matchedName = matchedPart.name;
                        } else {
                            updated.rawsId = 0;
                            updated.matched = false;
                            updated.matchedName = '';
                        }
                    }

                    return updated;
                }
                return ing;
            });

            // If updating partId, also clear search and close dropdown
            if (field === 'partId') {
                const newSearchTerms = { ...prevState.partIdSearchTerms };
                delete newSearchTerms[ingredientId];
                const newDropdownOpen = { ...prevState.partIdDropdownOpen };
                delete newDropdownOpen[ingredientId];

                return {
                    extractedIngredients,
                    partIdSearchTerms: newSearchTerms,
                    partIdDropdownOpen: newDropdownOpen
                };
            }

            return { extractedIngredients };
        });
    }

    // Handle Part ID search input change
    handlePartIdSearch = (ingredientId, searchTerm) => {
        this.setState(prevState => ({
            partIdSearchTerms: {
                ...prevState.partIdSearchTerms,
                [ingredientId]: searchTerm
            },
            partIdDropdownOpen: {
                ...prevState.partIdDropdownOpen,
                [ingredientId]: true
            }
        }));
    }

    // Toggle Part ID dropdown
    togglePartIdDropdown = (ingredientId, open) => {
        this.setState(prevState => ({
            partIdDropdownOpen: {
                ...prevState.partIdDropdownOpen,
                [ingredientId]: open
            }
        }));
    }

    // Get filtered parts based on search term
    getFilteredParts = (ingredientId) => {
        const searchTerm = this.state.partIdSearchTerms[ingredientId] || '';
        if (!searchTerm) return this.state.ingredientParts;

        const lowerSearch = searchTerm.toLowerCase();
        return this.state.ingredientParts.filter(part =>
            part.name.toLowerCase().includes(lowerSearch) ||
            (part.id && part.id.toString().includes(searchTerm))
        );
    }

    importSelectedIngredients = () => {
        const ingredientsToImport = this.state.extractedIngredients.filter(ing =>
            this.state.selectedIngredients.includes(ing.id)
        );

        if (ingredientsToImport.length === 0) {
            toast.warning('Please select at least one ingredient to import');
            return;
        }

        // Import ALL selected ingredients, whether matched or not
        const allIngredients = ingredientsToImport.map(ing => ({
            RfqIngredientPartId: 0,
            RfqId: 0,
            PartID: ing.partId || '', // Use empty string if no Part ID
            PartName: ing.matchedName || ing.name,
            Amount: ing.amount,
            Overage:'',
            RawsId:ing.rawsId || 0,
            AmountPerServing:0,
            Unit: ing.unit,
            Source: 2,
            Type:0,
            OverageCost:0,
            IsCsm:0
        }));

        // Count matched vs unmatched
        const matchedCount = allIngredients.filter(ing => ing.partId).length;
        const unmatchedCount = allIngredients.length - matchedCount;

        this.setState(prevState => ({
            formData: {
                ...prevState.formData,
                ingredients: [...prevState.formData.ingredients, ...allIngredients]
            },
            showAIExtractionModal: false,
            extractedIngredients: [],
            selectedIngredients: []
        }));

        // Show appropriate success message
        if (unmatchedCount > 0) {
            toast.success(`Imported ${allIngredients.length} ingredient(s). ${unmatchedCount} need manual Part ID assignment.`);
        } else {
            toast.success(`Successfully imported ${allIngredients.length} ingredient(s)`);
        }
    }

    closeAIExtractionModal = () => {
        this.setState({
            showAIExtractionModal: false,
            extractedIngredients: [],
            selectedIngredients: []
        });
    }

    validateForm = () => {
        const errors = {};
        const { formData } = this.state;

        // Basic required fields
        if (!formData.company) errors.company = 'Company name is required';
        if (!formData.productName) errors.productName = 'Product name is required';
        if (!formData.form || formData.form === 'Select form' || formData.form === 'Select form type') errors.form = 'Product form is required';

        // Check for at least one ingredient
        if (!formData.ingredients || formData.ingredients.length === 0) {
            errors.ingredients = 'At least one ingredient is required';
        } else {
            // Check if all ingredients have required fields
            const invalidIngredients = formData.ingredients.filter(ingredient =>
                !ingredient.PartID || !ingredient.PartName || !ingredient.Amount || !ingredient.Unit
            );

            if (invalidIngredients.length > 0) {
                errors.ingredients = `${invalidIngredients.length} ingredient(s) are missing required information (Part ID, name, amount, or unit)`;
                console.log('Invalid ingredients:', invalidIngredients);
            }
        }

        // Check for at least two tiers with units (price is optional)
        const validTiers = formData.tiers ? formData.tiers.filter(tier =>
            tier.Unit && tier.Unit.trim() !== ''
        ) : [];
        if (validTiers.length < 2) {
            errors.tiers = 'At least two tiers with units are required';
        }

        // Debug logging
        if (Object.keys(errors).length > 0) {
            console.log('Validation errors:', errors);
            console.log('Form data:', formData);
        }

        return errors;
    }

    formatRFQData = (status = 'draft') => {
        const { formData, newSfpImages } = this.state;

        console.log("=======")
        console.log(formData)
        console.log("=======")

        // Main RFQ data mapping form fields to database columns
        const rfqData = {
            Company: formData.company || null,
            Address: formData.address || null,
            Contact: formData.contact || null,
            Phone: formData.phone || null,
            ProductName: formData.productName || null,
            Form: formData.form !== 'Select form' ? formData.form : null,
            ServingSize: formData.servingSize || null,
            ServingUnit: null,  // Legacy field, no longer used
            Formula: formData.formula || null,
            PackagingType: formData.packagingType || null,
            PackagingCsm: formData.packagingCsm ? 1 : 0,
            BottleType: formData.bottleType !== 'Select bottle type' ? formData.bottleType : null,
            BottleColor: formData.bottleColor !== 'Select bottle color' ? formData.bottleColor : null,
            CustomBottleColor : formData.customBottleColor || ' ',
            MasterCaseDimensions: formData.masterCaseDimensions || ' ',
            CountPerCase: formData.countPerCase || ' ',
            ClosureType: formData.closureType !== 'Select closure type' ? formData.closureType : null,
            CustomClosureType : formData.customClosureType || ' ',
            ClosureColor: formData.closureColor !== 'Select closure color' ? formData.closureColor : null,
            CustomClosureColor : formData.customClosureColor || ' ',
            CapLinerType: formData.capLinerType !== 'Select cap liner type' ? formData.capLinerType : null,
            LabelType: formData.labelType !== 'Select label type' ? formData.labelType : null,
            CustomLabelSpecifications: formData.customLabelSpecifications || null,
            DielineFileId: formData.dielineFileId || null,
            Cotton: formData.cotton || false,
            Desiccant: formData.desiccant || false,
            NeckShrink: formData.neckShrink || false,
            ProductBox: formData.productBox || false,
            ProductInsert: formData.productInsert || false,
            ClosureSticker: formData.closureSticker || false,
            MasterCase: formData.masterCase || false,
            Sleeve: formData.sleeve ? 1 : 0,
            Hangtag: formData.hangtag ? 1 : 0,
            TestingRequired: formData.testingRequired ? 1 : 0,
            AllergenFree: formData.allergenFree || false,
            CertifiedOrganic: formData.certifiedOrganic || false,
            Kitting: formData.kitting || false,
            AdditionalInformationNotes: formData.notes || null,
            ShippingMethod: formData.shippingMethod !== 'Select shipping method' ? formData.shippingMethod : null,
            PaymentTerms: formData.paymentTerms || null,
            RfqStatus: status === 'draft' ? 1 : 2,
            SalesRep: formData.salesRep,
            OrderType: formData.orderType,
            ItemNumber: formData.itemNumber || null,
            SharepointLink: formData.sharepointLink || null,
            DealType: formData.dealType || null,
            TargetCompDate: formData.targetCompDate || null,
            ItemName: formData.itemName || null,
            QuotePriority: formData.quotePriority || null,
            Complexity: formData.complexity || null,
            Terms: formData.terms || null,
            UnitCount: formData.unitCount || null
        };

        // Prepare ingredients data
        const ingredients = formData.ingredients.map((ingredient, index) => ({
            RfqIngredientPartId: ingredient.RfqIngredientPartId,
            RfqId: ingredient.RfqId,
            PartID: ingredient.PartID,
            PartName: ingredient.PartName,
            Amount: ingredient.Amount,
            Overage: ingredient.Overage,
            RawsId: ingredient.RawsId,
            AmountPerServing: ingredient.AmountPerServing,
            Unit: ingredient.Unit,
            Source: ingredient.Source,
            Type: ingredient.Type,
            OverageCost: ingredient.OverageCost,
            IsCsm: ingredient.IsCsm,
            deleted: ingredient.deleted
        }));

        // Prepare testing data
        const testing = [];

        // Get all non-deleted serving units that have been saved (have valid RfqServingUnitId)
        // For new serving units (RfqServingUnitId = 0), the backend will create testing records after saving
        const savedServingUnits = formData.servingsUnit.filter(
            unit => !unit.deleted && unit.ServingUnit && unit.RfqServingUnitId > 0
        );

        // Add Micro, Heavy Metal, and Assay as testing entries if checked
        // Create one entry for each SAVED serving unit
        // For new serving units, send a flag to backend to create testing records
        if (formData.testingReqMicro) {
            if (savedServingUnits.length > 0) {
                savedServingUnits.forEach((servingUnit) => {
                    testing.push({
                        TestName: 'Micro',
                        RfqId: this.state.rfqId || 0,
                        RfqTestingId: 0, // Will be assigned by backend
                        RfqServingUnitId: servingUnit.RfqServingUnitId
                    });
                });
            } else {
                // If no saved serving units yet, send one record without RfqServingUnitId
                // Backend will handle creating records for all serving units
                testing.push({
                    TestName: 'Micro',
                    RfqId: this.state.rfqId || 0,
                    RfqTestingId: 0
                });
            }
        } else if (formData.microTestingIds && formData.microTestingIds.length > 0) {
            // Mark all existing Micro tests as deleted if unchecked
            formData.microTestingIds.forEach(testingId => {
                testing.push({
                    TestName: 'Micro',
                    RfqId: this.state.rfqId,
                    RfqTestingId: testingId,
                    deleted: 1
                });
            });
        }

        if (formData.testingReqHeavyMetal) {
            if (savedServingUnits.length > 0) {
                savedServingUnits.forEach((servingUnit) => {
                    testing.push({
                        TestName: 'Heavy Metal',
                        RfqId: this.state.rfqId || 0,
                        RfqTestingId: 0, // Will be assigned by backend
                        RfqServingUnitId: servingUnit.RfqServingUnitId
                    });
                });
            } else {
                testing.push({
                    TestName: 'Heavy Metal',
                    RfqId: this.state.rfqId || 0,
                    RfqTestingId: 0
                });
            }
        } else if (formData.heavyMetalTestingIds && formData.heavyMetalTestingIds.length > 0) {
            // Mark all existing Heavy Metal tests as deleted if unchecked
            formData.heavyMetalTestingIds.forEach(testingId => {
                testing.push({
                    TestName: 'Heavy Metal',
                    RfqId: this.state.rfqId,
                    RfqTestingId: testingId,
                    deleted: 1
                });
            });
        }

        if (formData.testingReqAssay) {
            if (savedServingUnits.length > 0) {
                savedServingUnits.forEach((servingUnit) => {
                    testing.push({
                        TestName: 'Assay',
                        RfqId: this.state.rfqId || 0,
                        RfqTestingId: 0, // Will be assigned by backend
                        RfqServingUnitId: servingUnit.RfqServingUnitId
                    });
                });
            } else {
                testing.push({
                    TestName: 'Assay',
                    RfqId: this.state.rfqId || 0,
                    RfqTestingId: 0
                });
            }
        } else if (formData.assayTestingIds && formData.assayTestingIds.length > 0) {
            // Mark all existing Assay tests as deleted if unchecked
            formData.assayTestingIds.forEach(testingId => {
                testing.push({
                    TestName: 'Assay',
                    RfqId: this.state.rfqId,
                    RfqTestingId: testingId,
                    deleted: 1
                });
            });
        }

        formData.testInputs.forEach((testInput, index) => {
            if (testInput) {
                const testData = {
                    TestName: testInput.TestName || testInput.trim(),
                    RfqId: testInput.RfqId,
                    RfqTestingId: testInput.RfqTestingId
                };
                if (testInput.deleted === 1) {
                    testData.deleted = 1;
                }
                testing.push(testData);
            }
        });

        // Prepare tiers data 
        const tiers = [];
        formData.tiers.forEach((tier, index) => {
            if(tier)
            {
                const parsedPrice = tier.Price ? parseFloat(tier.Price) : null;
                tiers.push({
                    TierNumber: tier.TierNumber || index + 1,
                    Unit: tier.Unit,
                    Price: (parsedPrice !== null && !isNaN(parsedPrice)) ? parsedPrice : null,
                    RfqTierId: tier.RfqTierId,
                    RfqId: tier.RfqId,
                    deleted: tier.deleted
                });
            }
        });

        // Prepare notes data
        const notes = [];
        formData.notesList.forEach((note) => {
            if (note && note.NoteText && note.NoteText.trim() !== '') {
                notes.push({
                    NoteText: note.NoteText.trim(),
                    RfqId: note.RfqId || 0,
                    RfqNoteId: note.RfqNoteId || 0,
                    UserId: note.UserId || 0
                });
            }
        });

        // Prepare packaging parts data
        const packagingParts = [];
        this.state.packagingParts.forEach((part) => {
            // Include parts that have PartID OR are marked as deleted (so backend can delete them)
            if (part && (part.PartID || part.deleted)) {
                const packagingPartData = {
                    RfqPackagingPartId: part.RfqPackagingPartId || 0,
                    RfqId: part.RfqId || 0,
                    PartID: part.PartID,
                    PartName: part.PartName,
                    RawsId: part.RawsId || 0,
                    IsCsm: part.IsCsm || 0,
                    RfqServingUnitId: part.RfqServingUnitId || 0
                };

                // Only add deleted key if it's true (use 1 for deleted)
                if (part.deleted) {
                    packagingPartData.deleted = 1;
                }

                packagingParts.push(packagingPartData);
            }
        });


        // Prepare serving units data
        const servingUnits = [];
        if (formData.servingsUnit && Array.isArray(formData.servingsUnit)) {
            formData.servingsUnit.forEach((unit) => {
                // Skip units that are marked as deleted and don't have an ID (not in database)
                if (unit && unit.deleted && (!unit.RfqServingUnitId || unit.RfqServingUnitId === 0)) {
                    return;
                }

                // Include units that have a value OR are marked deleted with an ID
                if (unit && (unit.ServingUnit || (unit.deleted && unit.RfqServingUnitId > 0))) {
                    const servingUnitData = {
                        RfqServingUnitId: unit.RfqServingUnitId || 0,
                        RfqId: unit.RfqId || 0,
                        ServingUnit: unit.ServingUnit || ''
                    };

                    // Only add deleted key if it's true (use 1 for deleted)
                    if (unit.deleted) {
                        servingUnitData.deleted = 1;
                    }

                    servingUnits.push(servingUnitData);
                }
            });
        }


        return {
            rfq: rfqData,
            ingredients: ingredients,
            testing: testing,
            tiers: tiers,
            notes: notes,
            packagingParts: packagingParts,
            servingUnits: servingUnits,
            newSfpImages: newSfpImages
        };
    }

    handleSubmit = async (e) => {
        e.preventDefault();

        const errors = this.validateForm();
        if (Object.keys(errors).length > 0) {
            this.setState({ errors });
            toast.error('Please fill in all required fields');
            return;
        }

        this.setState({ loading: true });

        try {
            // Format data to match API model
            const rfqData = this.formatRFQData('submitted');

            let response;
            if (this.state.isEditMode) {
                // Update existing RFQ
                const url = this.state.tempId
                    ? `/rfq/save?rfq_id=${this.state.rfqId}&temp_id=${this.state.tempId}`
                    : `/rfq/save?rfq_id=${this.state.rfqId}`;
                response = await axios.post(url, rfqData);
                toast.success('RFQ updated successfully!');
            } else {
                // Create new RFQ
                const url = this.state.tempId
                    ? `/rfq/create?temp_id=${this.state.tempId}`
                    : '/rfq/create';
                response = await axios.post(url, rfqData);
                if (response.data && response.data.RfqId) {
                    toast.success('RFQ submitted successfully!');
                } else {
                    throw new Error('Invalid response from server');
                }
            }

            setTimeout(() => {
                window.location.href = '/formula';
            }, 2000);
        } catch (error) {
            toast.error(`Failed to submit RFQ`);
        } finally {
            this.setState({ loading: false });
        }
    }

    handleSaveDraft = async () => {
        this.setState({ savingDraft: true });

        try {
            // Format data to match API model with draft status
            const rfqData = this.formatRFQData('draft');


            let response;

            let url;
            if (this.state.isEditMode) {
                url = this.state.tempId
                    ? `/rfq/save?rfq_id=${this.state.rfqId}&temp_id=${this.state.tempId}`
                    : `/rfq/save?rfq_id=${this.state.rfqId}`;
            } else {
                url = this.state.tempId
                    ? `/rfq/save?temp_id=${this.state.tempId}`
                    : '/rfq/save';
            }

            // Single API call to merged endpoint
            response = await axios['post'](url, rfqData);

            // Show appropriate success message
            const message = this.state.isEditMode 
                ? 'Draft updated successfully!' 
                : 'Draft saved successfully!';
            toast.success(message);

            // Handle response
            if (response.data && response.data.RfqId) {
                // Switch to edit mode after first save
                if (!this.state.isEditMode) {
                    this.setState({
                        rfqId: response.data.RfqId,
                        isEditMode: true
                    });
                }

                // Redirect to /request-quote after successful save
                setTimeout(() => {
                    window.location.href = '/request-quote';
                }, 1500);
            } else {
                throw new Error('Invalid response from server');
            }
        } catch (error) {
            console.error(`Error ${this.state.isEditMode ? 'updating' : 'saving'} draft:`, error);

            // More detailed error message
            const errorMessage = error.response?.data?.detail || error.message || 'Unknown error occurred';
            console.error('Full error details:', {
                status: error.response?.status,
                statusText: error.response?.statusText,
                data: error.response?.data,
                message: error.message
            });

            toast.error(`Failed to ${this.state.isEditMode ? 'update' : 'save'} draft: ${errorMessage}`);
        } finally {
            this.setState({ savingDraft: false });
        }
    }

    saveNoteToDatabase = async (noteText) => {
        try {
            // Prepare note data
            const noteData = {
                notes: [{
                    RfqNoteId: 0,
                    RfqId: this.state.rfqId,
                    NoteText: noteText
                }]
            };

            // Save note to database
            await axios.post(`/rfq/save?rfq_id=${this.state.rfqId}`, noteData);

            toast.success('Note added successfully!');
            return true;
        } catch (error) {
            console.error('Error saving note:', error);
            toast.error('Failed to save note');
            return false;
        }
    }

    loadNotesFromDatabase = async () => {
        try {
            const response = await axios.get(`/rfq/${this.state.rfqId}`);
            const responseData = response.data;

            // Map notes data to form format
            let notesList = [];
            if (responseData.notes && responseData.notes.length > 0) {
                notesList = responseData.notes.map(note => ({
                    RfqNoteId: note.RfqNoteId || 0,
                    RfqId: note.RfqId || 0,
                    NoteText: note.NoteText || '',
                    UserId: note.UserId || 0,
                    CreatedDateTime: note.CreatedDateTime,
                    Username: note.Username || '',
                    Replies: note.Replies ? note.Replies.map(reply => ({
                        RfqNoteReplyId: reply.RfqNoteReplyId || 0,
                        RfqNoteId: reply.RfqNoteId || 0,
                        NoteText: reply.NoteText || '',
                        UserId: reply.UserId || 0,
                        CreatedDateTime: reply.CreatedDateTime,
                        Username: reply.Username || ''
                    })) : []
                }));
            }

            this.setState(prevState => ({
                formData: {
                    ...prevState.formData,
                    notesList: notesList
                }
            }));
        } catch (error) {
            console.error('Error loading notes:', error);
        }
    }

    saveReplyToDatabase = async (parentNote, replyText) => {
        try {
            // Prepare reply data
            const replyData = {
                RfqNoteId: parentNote.RfqNoteId,
                RfqId: this.state.rfqId,
                NoteText: replyText,
                ParentUserId: parentNote.UserId // User ID of the parent note author for notification
            };

            console.log('Sending reply data:', replyData);

            // Save reply to database
            const response = await axios.post(`/rfq/notes/reply`, replyData, {
                headers: {
                    'Content-Type': 'application/json'
                }
            });

            console.log('Reply response:', response.data);

            toast.success('Reply added successfully!');
            return true;
        } catch (error) {
            console.error('Error saving reply:', error);
            console.error('Error response:', error.response?.data);
            toast.error('Failed to save reply');
            return false;
        }
    }

    render() {
        const { formData, loading, savingDraft, errors, isLoading, isEditMode } = this.state;

        if (isLoading) {
            return (
                <Layout>
                    <div style={{ height: 'calc(100vh - 70px)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <div style={{ textAlign: 'center' }}>
                            <div className="spinner-border" role="status">
                                <span className="visually-hidden"></span>
                            </div>
                            <p style={{ marginTop: '10px' }}>Loading RFQ data...</p>
                        </div>
                    </div>
                </Layout>
            );
        }

        return (
            <Layout>
                <style>{formStyles}</style>
                <div style={{ height: 'calc(100vh - 70px)', overflow: 'auto', paddingTop: '20px' }}>
                    <section className="section pb-0" style={{ paddingTop: '20px' }}>
                        <div style={{ paddingLeft: '24px', paddingRight: '24px', maxWidth: '100%', width: '100%' }}>

                            {/* Header */}
                            <div className="mb-4" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                <div style={{ fontSize: '28px', fontWeight: 'bold', margin: 0, color: '#000000' }}>
                                    
                                </div>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                    <Form.Label style={{ fontSize: '14px', margin: 0, whiteSpace: 'nowrap' }}>Sales Rep <i className="fa-solid fa-asterisk" style={{ fontSize: '8px', color: '#dc3545' }}></i></Form.Label>
                                    <Form.Control
                                        as="select"
                                        name="salesRep"
                                        value={formData.salesRep}
                                        onChange={this.handleInputChange}
                                        style={{ width: '200px' }}
                                        required
                                    >
                                        <option value="">Select Sales Rep</option>
                                        {this.state.salesReps.map(rep => (
                                            <option key={rep.id} value={rep.id}>
                                                {rep.fullname}
                                            </option>
                                        ))}
                                    </Form.Control>
                                </div>
                            </div>

                            <Form onSubmit={this.handleSubmit}>
                                {/* Customer Information */}
                                <div className="form-section">
                                    <div className="section-header">
                                        <h5 style={{ margin: 0, fontSize: '16px', fontWeight: '600' }}>Customer Information</h5>
                                    </div>
                                    <div className="section-content">
                                        <Row>
                                            <Col md={6}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Customer <i className="fa-solid fa-asterisk" style={{ fontSize: '8px', color: '#dc3545' }}></i></Form.Label>
                                                    <Form.Control
                                                        as="select"
                                                        name="company"
                                                        value={formData.company}
                                                        onChange={this.handleCustomerChange}
                                                        isInvalid={!!errors.company}
                                                        disabled={this.state.loadingCustomers}
                                                    >
                                                        <option value="">
                                                            {this.state.loadingCustomers ? 'Loading customers...' : 'Select Customer'}
                                                        </option>
                                                        {this.state.customers.map((customer, index) => (
                                                            <option key={index} value={customer.customer_name}>
                                                                {customer.customer_name}
                                                            </option>
                                                        ))}
                                                    </Form.Control>
                                                    <Form.Control.Feedback type="invalid">
                                                        {errors.company}
                                                    </Form.Control.Feedback>
                                                </Form.Group>
                                            </Col>
                                            <Col md={6}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Address</Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        name="address"
                                                        value={formData.address}
                                                        onChange={this.handleInputChange}
    
                                                    />
  
                                                </Form.Group>
                                            </Col>
                                            <Col md={6}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Contact</Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        name="contact"
                                                        value={formData.contact}
                                                        onChange={this.handleInputChange}
                                                    />
    
                                                </Form.Group>
                                            </Col>
                                            <Col md={6}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Phone</Form.Label>
                                                    <Form.Control
                                                        type="tel"
                                                        name="phone"
                                                        value={formData.phone}
                                                        onChange={this.handleInputChange}
                                                    />

                                                </Form.Group>
                                            </Col>
                                        </Row>
                                    </div>
                                </div>

                                {/* Product Information */}
                                <div className="form-section">
                                    <div className="section-header">
                                        <h5 style={{ margin: 0, fontSize: '16px', fontWeight: '600' }}>Product Information</h5>
                                    </div>
                                    <div className="section-content">
                                        <Row>
                                            <Col md={6}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Product Name <i className="fa-solid fa-asterisk" style={{ fontSize: '8px', color: '#dc3545' }}></i></Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        name="productName"
                                                        value={formData.productName}
                                                        onChange={this.handleInputChange}
                                                        isInvalid={!!errors.productName}
                                                    />
                                                    <Form.Control.Feedback type="invalid">
                                                        {errors.productName}
                                                    </Form.Control.Feedback>
                                                </Form.Group>
                                            </Col>
                                            <Col md={6}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label className="d-block">Form Type <i className="fa-solid fa-asterisk" style={{ fontSize: '8px', color: '#dc3545' }}></i></Form.Label>
                                                    <Form.Select
                                                        name="form"
                                                        value={formData.form}
                                                        onChange={this.handleInputChange}
                                                        isInvalid={!!errors.form}
                                                    >
                                                        <option>Select form type</option>
                                                        {(this.state.dropdownOptions.form_type || []).map(opt => (
                                                            <option key={opt.value} value={opt.value}>{opt.label}</option>
                                                        ))}
                                                    </Form.Select>
                                                    <Form.Control.Feedback type="invalid">
                                                        {errors.form}
                                                    </Form.Control.Feedback>
                                                </Form.Group>
                                            </Col>
                                            <Col md={6}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Serving Size</Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        name="servingSize"
                                                        placeholder="e.g., 2 capsules"
                                                        value={formData.servingSize}
                                                        onChange={this.handleInputChange}
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col md={6}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Servings/Unit</Form.Label>
                                                    {formData.servingsUnit && formData.servingsUnit.map((unit, index) => {
                                                        // Skip deleted units
                                                        if (unit.deleted) return null;

                                                        const activeUnits = formData.servingsUnit.filter(u => !u.deleted);
                                                        const showDeleteButton = activeUnits.length > 1;

                                                        return (
                                                            <div key={index} className="d-flex align-items-center mb-2">
                                                                <Form.Control
                                                                    type="text"
                                                                    placeholder="e.g., 30"
                                                                    value={unit.ServingUnit}
                                                                    onChange={(e) => this.handleServingUnitChange(index, e.target.value)}
                                                                />
                                                                {showDeleteButton && (
                                                                    <i
                                                                        className="ti-trash text-danger ms-2"
                                                                        style={{ cursor: 'pointer', fontSize: '18px' }}
                                                                        onClick={() => this.removeServingUnit(index)}
                                                                        title="Remove serving unit"
                                                                    />
                                                                )}
                                                            </div>
                                                        );
                                                    })}
                                                    <button
                                                        type="button"
                                                        className="btn btn-sm btn-outline-primary mt-2"
                                                        onClick={this.addServingUnit}
                                                    >
                                                        <i className="ti-plus"></i> Add Serving Unit
                                                    </button>
                                                </Form.Group>
                                            </Col>
                                            <Col md={6}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label className="d-block">Order Type</Form.Label>
                                                    <Form.Select
                                                        name="orderType"
                                                        value={formData.orderType}
                                                        onChange={this.handleInputChange}
                                                    >
                                                        <option value="">Select order type</option>
                                                        {(this.state.dropdownOptions.order_type || []).map(opt => (
                                                            <option key={opt.value} value={opt.value}>{opt.label}</option>
                                                        ))}
                                                    </Form.Select>
                                                </Form.Group>
                                            </Col>
                                            <Col md={6}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Item Number</Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        name="itemNumber"
                                                        placeholder="Enter item number"
                                                        value={formData.itemNumber}
                                                        onChange={this.handleInputChange}
                                                    />
                                                </Form.Group>
                                            </Col>
                                            {formData.orderType && formData.orderType !== '' && formData.sharepointLink && (
                                                <Col md={6}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Sharepoint Link</Form.Label>
                                                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                            <Form.Control
                                                                type="text"
                                                                name="sharepointLink"
                                                                placeholder="Enter sharepoint link"
                                                                value={formData.sharepointLink}
                                                                readOnly
                                                                style={{ flex: 1, backgroundColor: '#f8f9fa', cursor: 'pointer' }}
                                                                onClick={() => window.open(formData.sharepointLink, '_blank')}
                                                            />
                                                            <a
                                                                href={formData.sharepointLink}
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                                style={{
                                                                    color: '#007bff',
                                                                    cursor: 'pointer',
                                                                    fontSize: '18px',
                                                                    textDecoration: 'none'
                                                                }}
                                                                title="Open in new tab"
                                                            >
                                                                <i className="ti-new-window"></i>
                                                            </a>
                                                        </div>
                                                    </Form.Group>
                                                </Col>
                                            )}
                                            {/* <Col md={12}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Formula</Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        name="formula"
                                                        placeholder="Enter formula details"
                                                        value={formData.formula}
                                                        onChange={this.handleInputChange}
                                                    />
                                                </Form.Group>
                                            </Col> */}
                                        </Row>
                                    </div>
                                </div>

                                {/* Formula Specifications Requested */}
                                <div className="form-section">
                                    <div
                                        className="section-header"
                                        onClick={() => this.toggleSection('formulaSpecs')}
                                        style={{ cursor: 'pointer', position: 'relative' }}
                                    >
                                        <h5 style={{ margin: 0, fontSize: '16px', fontWeight: '600' }}>Formula Specifications Requested <i className="fa-solid fa-asterisk" style={{ fontSize: '8px', color: '#dc3545' }}></i></h5>
                                        <span
                                            style={{
                                                position: 'absolute',
                                                right: '24px',
                                                top: '50%',
                                                transform: 'translateY(-50%)',
                                                fontSize: '14px',
                                                color: '#6b7280',
                                                transition: 'transform 0.2s ease'
                                            }}
                                        >
                                            {this.state.expandedSections.formulaSpecs ? '▼' : '►'}
                                        </span>
                                    </div>
                                    {this.state.expandedSections.formulaSpecs && (
                                        <div className="section-content">
                                            <Row>
                                                <Col md={12}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>AI Formula Extraction</Form.Label>
                                                        <div className="mb-3">
                                                            <small className="text-muted">
                                                                Upload Supplement Facts Label or Ingredient List<br/>
                                                                Upload an image (JPG, PNG) or PDF of your supplement facts panel. AI will extract ingredient names and dosages.
                                                            </small>
                                                        </div>
                                                        <div
                                                            className="upload-area"
                                                            onClick={() => !this.state.extractionLoading && document.getElementById('file-upload').click()}
                                                            style={{
                                                                opacity: this.state.extractionLoading ? 0.6 : 1,
                                                                cursor: this.state.extractionLoading ? 'not-allowed' : 'pointer'
                                                            }}
                                                        >
                                                            <input
                                                                type="file"
                                                                id="file-upload"
                                                                hidden
                                                                accept=".jpg,.jpeg,.png,.pdf"
                                                                onChange={this.handleFileUpload}
                                                                disabled={this.state.extractionLoading}
                                                            />
                                                            {this.state.extractionLoading ? (
                                                                <>
                                                                    <div className="spinner-border text-primary mb-2" role="status">
                                                                        <span className="visually-hidden"></span>
                                                                    </div>
                                                                    <p style={{ margin: 0 }}>Extracting ingredients...</p>
                                                                </>
                                                            ) : (
                                                                <>
                                                                    <i className="ti-upload" style={{ fontSize: '24px', marginBottom: '10px' }}></i>
                                                                    <p style={{ margin: 0 }}>Choose file - No file chosen</p>
                                                                </>
                                                            )}
                                                        </div>
                                                    </Form.Group>
                                                </Col>
                                            </Row>

                                            <div className="mb-4">
                                                <h6 style={{ fontWeight: '600', marginBottom: '16px' }}>Add Ingredient Manually</h6>
                                                {errors.ingredients && (
                                                    <div className="alert alert-danger" role="alert" style={{ padding: '8px 12px', fontSize: '14px', marginBottom: '16px' }}>
                                                        {errors.ingredients}
                                                    </div>
                                                )}

                                                <div className='row'>
                                                    <div className='col-6'>
                                                        <ImageGrid imageUrls={this.state.sfpImages} />
                                                    </div>
                                                </div>

                                                {/* Ingredient Rows */}
                                                {formData.ingredients.map((ingredient, index) => (
                                                    <Row key={index} className={`align-items-end${ingredient.deleted === 1 ? ' hide-me' : ''}`} style={{ marginBottom: '10px' }}>
                                                        <Col md={2}>
                                                            <Form.Group className="mb-2">
                                                                <Form.Label style={{ fontSize: '12px', fontWeight: '600', color: '#374151' }}>Part ID#</Form.Label>
                                                                <Form.Control
                                                                    size="sm"
                                                                    type="text"
                                                                    placeholder="60001"
                                                                    value={ingredient.partId || ''}
                                                                    onChange={(e) => this.handleIngredientPartIdChange(index, e.target.value)}
                                                                    disabled={this.state.loadingParts}
                                                                    style={{ fontSize: '14px' }}
                                                                />
                                                            </Form.Group>
                                                        </Col>
                                                        <Col md={3}>
                                                            <Form.Group className="mb-2 searchable-dropdown">
                                                                <Form.Label style={{ fontSize: '12px', fontWeight: '600', color: '#374151' }}>Ingredient Name <i className="fa-solid fa-asterisk" style={{ fontSize: '8px', color: '#dc3545' }}></i></Form.Label>
                                                                <Form.Control
                                                                    size="sm"
                                                                    type="text"
                                                                    placeholder={this.state.loadingParts ? 'Loading ingredients...' : 'Search ingredients...'}
                                                                    value={ingredient.name || ''}
                                                                    onChange={(e) => this.handleIngredientNameSearch(e.target.value, index)}
                                                                    onFocus={() => this.handleIngredientRowFocus(index)}
                                                                    onBlur={this.handleIngredientInputBlur}
                                                                    disabled={this.state.loadingParts}
                                                                    autoComplete="off"
                                                                    style={{ fontSize: '14px' }}
                                                                />
                                                                {this.state.showIngredientDropdown && this.state.activeDropdownIndex === index && (
                                                                    <div className="dropdown-list">
                                                                        {this.state.filteredIngredients.length > 0 ? (
                                                                            this.state.filteredIngredients.map(part => (
                                                                                <div
                                                                                    key={part.id}
                                                                                    className="dropdown-item-custom"
                                                                                    onMouseDown={() => this.selectIngredientForRow(part, index)}
                                                                                >
                                                                                    <strong>{part.id}</strong> - {part.name}
                                                                                </div>
                                                                            ))
                                                                        ) : (
                                                                            <div className="no-results">
                                                                                {this.state.loadingParts ? 'Loading ingredients...' : 'No matching ingredients found'}
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                )}
                                                            </Form.Group>
                                                        </Col>
                                                        <Col md={2}>
                                                            <Form.Group className="mb-2">
                                                                <Form.Label style={{ fontSize: '12px', fontWeight: '600', color: '#374151' }}>Label Claim</Form.Label>
                                                                <Form.Control
                                                                    size="sm"
                                                                    type="text"
                                                                    placeholder="90"
                                                                    value={ingredient.amount || ''}
                                                                    onChange={(e) => this.handleIngredientFieldChange(index, 'amount', e.target.value)}
                                                                    style={{ fontSize: '14px' }}
                                                                />
                                                            </Form.Group>
                                                        </Col>
                                                        <Col md={2}>
                                                            <Form.Group className="mb-2">
                                                                <Form.Label style={{ fontSize: '12px', fontWeight: '600', color: '#374151' }}>Unit</Form.Label>
                                                                <Form.Select
                                                                    size="sm"
                                                                    value={ingredient.unit || ''}
                                                                    onChange={(e) => this.handleIngredientFieldChange(index, 'unit', e.target.value)}
                                                                    style={{ fontSize: '13px', padding: '0.25rem 0.3rem' }}
                                                                >
                                                                    <option value="">Select unit</option>
                                                                    {(this.state.dropdownOptions.unit_type || []).map(opt => (
                                                                        <option key={opt.value} value={opt.value}>{opt.label}</option>
                                                                    ))}
                                                                </Form.Select>
                                                            </Form.Group>
                                                        </Col>
                                                        <Col md={1} className="text-center">
                                                            <Form.Group className="mb-2">
                                                                <Form.Label style={{ fontSize: '12px', fontWeight: '600', color: '#374151' }}>Source</Form.Label>
                                                                <div
                                                                    onClick={() => this.toggleIngredientCSM(index)}
                                                                    style={{
                                                                        cursor: 'pointer',
                                                                        fontSize: '14px',
                                                                        color: ingredient.IsCsm ? '#10b981' : '#6b7280',
                                                                        height: '31px',
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        justifyContent: 'center',
                                                                        border: '1px solid transparent'
                                                                    }}
                                                                    title={ingredient.IsCsm ? 'CSM' : 'Click to mark as CSM'}
                                                                >
                                                                    {ingredient.IsCsm ? 'CSM' : <i className="ti-check-box" style={{ fontSize: '18px' }}></i>}
                                                                </div>
                                                            </Form.Group>
                                                        </Col>
                                                        <Col md={1} className="text-center">
                                                            <Form.Group className="mb-2">
                                                                <Form.Label style={{ fontSize: '12px', fontWeight: '600', color: '#374151' }}>Actions</Form.Label>
                                                                <div>
                                                                    <button
                                                                        type="button"
                                                                        style={{ background: 'none', border: 'none', color: '#ef4444', cursor: 'pointer' }}
                                                                        onClick={() => this.removeIngredient(index)}
                                                                        title="Delete"
                                                                    >
                                                                        <i className="ti-trash"></i>
                                                                    </button>
                                                                </div>
                                                            </Form.Group>
                                                        </Col>
                                                    </Row>
                                                ))}

                                                <Row>
                                                    <Col md={12}>
                                                        <button
                                                            type="button"
                                                            onClick={this.addIngredient}
                                                            style={{
                                                                background: 'none',
                                                                border: 'none',
                                                                color: '#4FC3F7',
                                                                cursor: 'pointer',
                                                                fontSize: '14px',
                                                                padding: '8px 0'
                                                            }}
                                                        >
                                                            <i className="ti-plus" style={{ marginRight: '5px' }}></i>
                                                            Add Ingredient
                                                        </button>
                                                    </Col>
                                                </Row>
                                            </div>
                                        </div>
                                    )}
                                </div>

                                {/* Packaging Specifications Requested */}
                                <div className="form-section">
                                    <div
                                        className="section-header"
                                        onClick={() => this.toggleSection('packagingSpecs')}
                                        style={{ cursor: 'pointer', position: 'relative' }}
                                    >
                                        <h5 style={{ margin: 0, fontSize: '16px', fontWeight: '600' }}>Packaging Specifications Requested</h5>
                                        <span
                                            style={{
                                                position: 'absolute',
                                                right: '24px',
                                                top: '50%',
                                                transform: 'translateY(-50%)',
                                                fontSize: '14px',
                                                color: '#6b7280',
                                                transition: 'transform 0.2s ease'
                                            }}
                                        >
                                            {this.state.expandedSections.packagingSpecs ? '▼' : '►'}
                                        </span>
                                    </div>
                                    {this.state.expandedSections.packagingSpecs && (
                                        <div className="section-content">
                                            <Row>
                                                <Col md={4}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label className="d-block">Packaging Type</Form.Label>
                                                        <Form.Select
                                                            name="packagingType"
                                                            value={formData.packagingType}
                                                            onChange={this.handleInputChange}
                                                        >
                                                            <option value="">Select packaging type</option>
                                                            {(this.state.dropdownOptions.packaging_type || []).map(opt => (
                                                                <option key={opt.value} value={opt.value}>{opt.label}</option>
                                                            ))}
                                                        </Form.Select>
                                                    </Form.Group>
                                                </Col>
                                                <Col md={4} className="d-flex align-items-center">
                                                    <Form.Check
                                                        type="switch"
                                                        id="packagingCsm"
                                                        label="Customer Supplied Material (CSM)"
                                                        name="packagingCsm"
                                                        checked={formData.packagingCsm}
                                                        onChange={this.handleInputChange}
                                                    />
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col md={4}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label className="d-block">Bottle Type</Form.Label>
                                                        <Form.Select
                                                            name="bottleType"
                                                            value={formData.bottleType}
                                                            onChange={this.handleInputChange}
                                                        >
                                                            <option>Select bottle type</option>
                                                            {(this.state.dropdownOptions.bottle_type || []).map(opt => (
                                                                <option key={opt.value} value={opt.value}>{opt.label}</option>
                                                            ))}
                                                        </Form.Select>
                                                    </Form.Group>
                                                </Col>
                                                <Col md={4}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label className="d-block">Bottle Color</Form.Label>
                                                        <Form.Select
                                                            name="bottleColor"
                                                            value={formData.bottleColor}
                                                            onChange={this.handleInputChange}
                                                        >
                                                            <option>Select bottle color</option>
                                                            {(this.state.dropdownOptions.bottle_color || []).map(opt => (
                                                                <option key={opt.value} value={opt.value}>{opt.label}</option>
                                                            ))}
                                                        </Form.Select>
                                                    </Form.Group>
                                                </Col>
                                                <Col md={4}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label className="d-block">Closure Type</Form.Label>
                                                        <Form.Select
                                                            name="closureType"
                                                            value={formData.closureType}
                                                            onChange={this.handleInputChange}
                                                        >
                                                            <option>Select closure type</option>
                                                            {(this.state.dropdownOptions.closure_type || []).map(opt => (
                                                                <option key={opt.value} value={opt.value}>{opt.label}</option>
                                                            ))}
                                                        </Form.Select>
                                                    </Form.Group>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col md={4}>

                                                </Col>
                                                <Col md={4}>
                                                    {formData.bottleColor === "Custom" && (
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Custom Bottle Color</Form.Label>
                                                            <Form.Control
                                                                type="text"
                                                                name="customBottleColor"
                                                                value={formData.customBottleColor || ''}
                                                                onChange={this.handleInputChange}
                                                                placeholder="Custom Bottle Color"
                                                            />
                                                        </Form.Group>
                                                    )}
                                                </Col>
                                                <Col md={4}>
                                                    {formData.closureType === "custom" && (
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Custom Closure Type</Form.Label>
                                                            <Form.Control
                                                                type="text"
                                                                name="customClosureType"
                                                                value={formData.customClosureType || ''}
                                                                onChange={this.handleInputChange}
                                                                placeholder="Custom Closure Type"
                                                            />
                                                        </Form.Group>
                                                    )}
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col md={4}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label className="d-block">Closure Color</Form.Label>
                                                        <Form.Select
                                                            name="closureColor"
                                                            value={formData.closureColor}
                                                            onChange={this.handleInputChange}
                                                        >
                                                            <option>Select closure color</option>
                                                            {(this.state.dropdownOptions.closure_color || []).map(opt => (
                                                                <option key={opt.value} value={opt.value}>{opt.label}</option>
                                                            ))}
                                                        </Form.Select>
                                                    </Form.Group>
                                                </Col>
                                                <Col md={4}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label className="d-block">Cap Liner Type</Form.Label>
                                                        <Form.Select
                                                            name="capLinerType"
                                                            value={formData.capLinerType}
                                                            onChange={this.handleInputChange}
                                                        >
                                                            <option>Select cap liner type</option>
                                                            {(this.state.dropdownOptions.cap_liner_type || []).map(opt => (
                                                                <option key={opt.value} value={opt.value}>{opt.label}</option>
                                                            ))}
                                                        </Form.Select>
                                                    </Form.Group>
                                                </Col>
                                                <Col md={4}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label className="d-block">Label Type</Form.Label>
                                                        <Form.Select
                                                            name="labelType"
                                                            value={formData.labelType}
                                                            onChange={this.handleInputChange}
                                                        >
                                                            <option>Select label type</option>
                                                            {(this.state.dropdownOptions.label_type || []).map(opt => (
                                                                <option key={opt.value} value={opt.value}>{opt.label}</option>
                                                            ))}
                                                        </Form.Select>
                                                    </Form.Group>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col md={4}>
                                                    {formData.closureColor === "Custom" && (
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Custom Closure Color</Form.Label>
                                                            <Form.Control
                                                                type="text"
                                                                name="customClosureColor"
                                                                value={formData.customClosureColor || ''}
                                                                onChange={this.handleInputChange}
                                                                placeholder="Custom Closure Color"
                                                            />
                                                        </Form.Group>
                                                    )}
                                                </Col>
                                                <Col md={4}>

                                                </Col>
                                                <Col md={4}>
                                                    {formData.labelType === "custom" && (
                                                        <>
                                                            <Form.Group className="mb-3">
                                                                <Form.Label>Custom Label Specifications</Form.Label>
                                                                <Form.Control
                                                                    type="text"
                                                                    name="customLabelSpecifications"
                                                                    value={formData.customLabelSpecifications || ''}
                                                                    onChange={this.handleInputChange}
                                                                    placeholder="Custom Label Specifications"
                                                                />
                                                            </Form.Group>
                                                            <Form.Group className="mb-3">
                                                                <Form.Label>Upload Dieline/Specifications</Form.Label>
                                                                {formData.dielineFile ? (
                                                                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                                                        <a
                                                                            href={formData.dielineFileUrl}
                                                                            target="_blank"
                                                                            rel="noopener noreferrer"
                                                                            style={{ textDecoration: 'none', color: '#007bff', cursor: 'pointer' }}
                                                                        >
                                                                            {formData.dielineFile}
                                                                        </a>
                                                                        <button
                                                                            type="button"
                                                                            onClick={() => this.setState(prevState => ({
                                                                                formData: {
                                                                                    ...prevState.formData,
                                                                                    dielineFile: '',
                                                                                    dielineFileUrl: '',
                                                                                    dielineFileId: null
                                                                                }
                                                                            }))}
                                                                            style={{
                                                                                background: 'none',
                                                                                border: 'none',
                                                                                color: '#dc3545',
                                                                                cursor: 'pointer',
                                                                                fontSize: '18px',
                                                                                padding: '0'
                                                                            }}
                                                                            title="Remove file"
                                                                        >
                                                                            ×
                                                                        </button>
                                                                    </div>
                                                                ) : (
                                                                    <Form.Control
                                                                        type="file"
                                                                        name="dielineFile"
                                                                        onChange={this.handleDielineFileChange}
                                                                    />
                                                                )}
                                                            </Form.Group>
                                                        </>
                                                    )}
                                                </Col>
                                            </Row>
                                            <hr style={{ margin: '20px 0', border: 'none', borderTop: '1px solid #e5e7eb' }} />
                                            <Row className="mt-3">
                                                <Col md={3}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Check
                                                            type="checkbox"
                                                            label="Cotton"
                                                            name="cotton"
                                                            checked={formData.cotton}
                                                            onChange={this.handleInputChange}
                                                            style={{ padding: '10px 0 10px 20px' }}
                                                        />
                                                    </Form.Group>
                                                </Col>
                                                <Col md={3}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Check
                                                            type="checkbox"
                                                            label="Desiccant"
                                                            name="desiccant"
                                                            checked={formData.desiccant}
                                                            onChange={this.handleInputChange}
                                                            style={{ padding: '10px 0 10px 20px' }}
                                                        />
                                                    </Form.Group>
                                                </Col>
                                                <Col md={3}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Check
                                                            type="checkbox"
                                                            label="Neck Shrink"
                                                            name="neckShrink"
                                                            checked={formData.neckShrink}
                                                            onChange={this.handleInputChange}
                                                            style={{ padding: '10px 0 10px 20px' }}
                                                        />
                                                    </Form.Group>
                                                </Col>
                                                <Col md={3}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Check
                                                            type="checkbox"
                                                            label="Product Box"
                                                            name="productBox"
                                                            checked={formData.productBox}
                                                            onChange={this.handleInputChange}
                                                            style={{ padding: '10px 0 10px 20px' }}
                                                        />
                                                    </Form.Group>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col md={3}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Check
                                                            type="checkbox"
                                                            label="Product Insert"
                                                            name="productInsert"
                                                            checked={formData.productInsert}
                                                            onChange={this.handleInputChange}
                                                            style={{ padding: '10px 0 10px 20px' }}
                                                        />
                                                    </Form.Group>
                                                </Col>
                                                <Col md={3}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Check
                                                            type="checkbox"
                                                            label="Closure Sticker"
                                                            name="closureSticker"
                                                            checked={formData.closureSticker}
                                                            onChange={this.handleInputChange}
                                                            style={{ padding: '10px 0 10px 20px' }}
                                                        />
                                                    </Form.Group>
                                                </Col>
                                                <Col md={3}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Check
                                                            type="checkbox"
                                                            label="Master Case"
                                                            name="masterCase"
                                                            checked={formData.masterCase}
                                                            onChange={this.handleInputChange}
                                                            style={{ padding: '10px 0 10px 20px' }}
                                                        />
                                                    </Form.Group>
                                                </Col>
                                                <Col md={3}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Check
                                                            type="checkbox"
                                                            label="Sleeve"
                                                            name="sleeve"
                                                            checked={formData.sleeve}
                                                            onChange={this.handleInputChange}
                                                            style={{ padding: '10px 0 10px 20px' }}
                                                        />
                                                    </Form.Group>
                                                </Col>
                                                <Col md={3}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Check
                                                            type="checkbox"
                                                            label="Hangtag"
                                                            name="hangtag"
                                                            checked={formData.hangtag}
                                                            onChange={this.handleInputChange}
                                                            style={{ padding: '10px 0 10px 20px' }}
                                                        />
                                                    </Form.Group>
                                                </Col>
                                            </Row>
                                            {formData.masterCase && (
                                                <Row>
                                                    <Col md={12}>
                                                        <Form.Label>Master Case Dimensions</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="masterCaseDimensions"
                                                            value={formData.masterCaseDimensions || ''}
                                                            onChange={this.handleInputChange}
                                                            placeholder="L x W x H (inches)"
                                                        />
                                                    </Col>
                                                    <Col md={12}>
                                                        <Form.Label>Count per Case</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="countPerCase"
                                                            value={formData.countPerCase || ''}
                                                            onChange={this.handleInputChange}
                                                            placeholder="Number of units per case"
                                                        />
                                                    </Col>
                                                </Row>
                                            )}
                                        </div>
                                    )}
                                </div>

                                {/* Packaging Parts Section - Multiple sections based on Servings/Unit */}
                                {formData.servingsUnit && formData.servingsUnit.filter(u => !u.deleted && u.ServingUnit).map((servingUnit, suIndex, filteredArray) => {
                                    const servingUnitId = servingUnit.RfqServingUnitId;
                                    const partsForThisUnit = this.state.packagingParts.filter(p => p.RfqServingUnitId === servingUnitId);
                                    const hasMultipleServingUnits = filteredArray.length > 1;

                                    return (
                                        <div key={suIndex} className="form-section">
                                            <div className="section-header">
                                                <h5 style={{ margin: 0, fontSize: '16px', fontWeight: '600' }}>
                                                    {hasMultipleServingUnits
                                                        ? `Packaging Parts - ${servingUnit.ServingUnit} Counts`
                                                        : 'Packaging Parts'}
                                                </h5>
                                            </div>
                                            <div className="section-content">
                                                {partsForThisUnit.map((part, index) => {
                                                    const globalIndex = this.state.packagingParts.indexOf(part);
                                                    return (
                                                        <Row key={globalIndex} className={`align-items-end${part.deleted === true ? ' hide-me' : ''}`} style={{ marginBottom: '10px' }}>
                                                            <Col md={3}>
                                                                <Form.Group className="mb-2">
                                                                    <Form.Label style={{ fontSize: '12px', fontWeight: '600', color: '#374151' }}>Part ID#</Form.Label>
                                                                    <Form.Control
                                                                        size="sm"
                                                                        placeholder="Part ID#"
                                                                        value={part.PartID}
                                                                        onChange={(e) => this.handlePartIdChange(globalIndex, e.target.value, 'packaging')}
                                                                        style={{ fontSize: '14px' }}
                                                                        id={`part-id-${globalIndex}`}
                                                                        name={`part-id-${globalIndex}`}
                                                                        autoComplete="off"
                                                                    />
                                                                </Form.Group>
                                                            </Col>
                                                            <Col md={4}>
                                                                <Form.Group className="mb-2 searchable-dropdown">
                                                                    <Form.Label style={{ fontSize: '12px', fontWeight: '600', color: '#374151' }}>Part Name</Form.Label>
                                                                    <Form.Control
                                                                        size="sm"
                                                                        type="text"
                                                                        placeholder={this.state.loadingParts ? 'Loading parts...' : 'Search packaging parts...'}
                                                                        value={part.PartName || ''}
                                                                        onChange={(e) => this.handlePackagingSearch(e.target.value, globalIndex)}
                                                                        onFocus={() => this.handlePackagingInputFocus(globalIndex)}
                                                                        onBlur={this.handlePackagingInputBlur}
                                                                        disabled={this.state.loadingParts}
                                                                        autoComplete="off"
                                                                        style={{ fontSize: '14px' }}
                                                                    />
                                                                    {this.state.showPackagingDropdown && this.state.activePackagingDropdownIndex === globalIndex && (
                                                                        <div className="dropdown-list">
                                                                            {this.state.filteredPackagingParts.length > 0 ? (
                                                                                this.state.filteredPackagingParts.slice(0, 50).map(part => (
                                                                                    <div
                                                                                        key={part.id}
                                                                                        className="dropdown-item-custom"
                                                                                        onMouseDown={() => this.selectPackagingPart(part, globalIndex)}
                                                                                    >
                                                                                        <strong>{part.id}</strong> - {part.name}
                                                                                    </div>
                                                                                ))
                                                                            ) : (
                                                                                <div className="no-results">
                                                                                    {this.state.loadingParts ? 'Loading packaging parts...' : 'No matching packaging parts found'}
                                                                                </div>
                                                                            )}
                                                                        </div>
                                                                    )}
                                                                </Form.Group>
                                                            </Col>
                                                            <Col md={1} className="text-center">
                                                                <Form.Group className="mb-2">
                                                                    <Form.Label style={{ fontSize: '12px', fontWeight: '600', color: '#374151' }}>Source</Form.Label>
                                                                    <div
                                                                        onClick={() => this.togglePackagingCSM(globalIndex)}
                                                                        style={{ cursor: 'pointer', fontSize: '14px', color: part.IsCsm ? '#10b981' : '#6b7280' }}
                                                                        title={part.IsCsm ? 'CSM' : 'Click to mark as CSM'}
                                                                    >
                                                                        {part.IsCsm ? 'CSM' : <i className="ti-check-box" style={{ fontSize: '18px' }}></i>}
                                                                    </div>
                                                                </Form.Group>
                                                            </Col>
                                                            <Col md={1} className="text-center">
                                                                <Form.Group className="mb-2">
                                                                    <Form.Label style={{ fontSize: '12px', fontWeight: '600', color: '#374151' }}>Actions</Form.Label>
                                                                    <div>
                                                                        <button
                                                                            type="button"
                                                                            style={{ background: 'none', border: 'none', color: '#ef4444', cursor: 'pointer' }}
                                                                            onClick={() => this.removePackagingPart(globalIndex)}
                                                                            title="Delete"
                                                                        >
                                                                            <i className="ti-trash"></i>
                                                                        </button>
                                                                    </div>
                                                                </Form.Group>
                                                            </Col>
                                                            <Col md={3}>
                                                                {/* Empty column for spacing */}
                                                            </Col>
                                                        </Row>
                                                    );
                                                })}

                                                <Row>
                                                    <Col md={12}>
                                                        <button
                                                            type="button"
                                                            className="btn btn-sm btn-outline-primary mt-2"
                                                            onClick={() => this.addPackagingPart(servingUnitId)}
                                                        >
                                                            <i className="ti-plus"></i> Add Packaging Part
                                                        </button>
                                                    </Col>
                                                </Row>
                                            </div>
                                        </div>
                                    );
                                })}

                                {/* Other Details */}
                                <div className="form-section">
                                    <div className="section-header">
                                        <h5 style={{ margin: 0, fontSize: '16px', fontWeight: '600' }}>Other Details</h5>
                                    </div>
                                    <div className="section-content">
                                        <Row>
                                            <Col md={6}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Deal Type</Form.Label>
                                                    <Form.Control
                                                        as="select"
                                                        name="dealType"
                                                        value={formData.dealType}
                                                        onChange={this.handleInputChange}
                                                    >
                                                        <option value="">Select Deal Type</option>
                                                        {(this.state.dropdownOptions.deal_type || []).map(opt => (
                                                            <option key={opt.value} value={opt.value}>{opt.label}</option>
                                                        ))}
                                                    </Form.Control>
                                                </Form.Group>
                                            </Col>
                                            <Col md={6}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Target Comp. Date (Current)</Form.Label>
                                                    <Form.Control
                                                        type="date"
                                                        name="targetCompDate"
                                                        value={formData.targetCompDate}
                                                        onChange={this.handleInputChange}
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col md={6}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Item Name</Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        name="itemName"
                                                        value={formData.itemName}
                                                        onChange={this.handleInputChange}
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col md={6}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Quote Priority</Form.Label>
                                                    <Form.Control
                                                        as="select"
                                                        name="quotePriority"
                                                        value={formData.quotePriority}
                                                        onChange={this.handleInputChange}
                                                    >
                                                        <option value="">Select Quote Priority</option>
                                                        {(this.state.dropdownOptions.quote_priority || []).map(opt => (
                                                            <option key={opt.value} value={opt.value}>{opt.label}</option>
                                                        ))}
                                                    </Form.Control>
                                                </Form.Group>
                                            </Col>
                                            <Col md={6}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Complexity</Form.Label>
                                                    <Form.Control
                                                        as="select"
                                                        name="complexity"
                                                        value={formData.complexity}
                                                        onChange={this.handleInputChange}
                                                    >
                                                        <option value="">Select Complexity</option>
                                                        {(this.state.dropdownOptions.complexity || []).map(opt => (
                                                            <option key={opt.value} value={opt.value}>{opt.label}</option>
                                                        ))}
                                                    </Form.Control>
                                                </Form.Group>
                                            </Col>
                                            <Col md={6}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Terms</Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        name="terms"
                                                        value={formData.terms}
                                                        onChange={this.handleInputChange}
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col md={6}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Unit Count (ea, kg, mL)</Form.Label>
                                                    <Form.Control
                                                        type="number"
                                                        step="0.01"
                                                        name="unitCount"
                                                        value={formData.unitCount}
                                                        onChange={this.handleInputChange}
                                                        placeholder="Enter unit count"
                                                    />
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                    </div>
                                </div>

                                {/* Testing Requirements */}
                                <div className="form-section">
                                    <div
                                        className="section-header"
                                        onClick={() => this.toggleSection('testingReqs')}
                                        style={{ cursor: 'pointer', position: 'relative' }}
                                    >
                                        <h5 style={{ margin: 0, fontSize: '16px', fontWeight: '600' }}>Testing Requirements</h5>
                                        <span
                                            style={{
                                                position: 'absolute',
                                                right: '24px',
                                                top: '50%',
                                                transform: 'translateY(-50%)',
                                                fontSize: '14px',
                                                color: '#6b7280',
                                                transition: 'transform 0.2s ease'
                                            }}
                                        >
                                            {this.state.expandedSections.testingReqs ? '▼' : '►'}
                                        </span>
                                    </div>
                                    {this.state.expandedSections.testingReqs && (
                                        <div className="section-content">
                                            <Form.Group className="mb-3">
                                                <Form.Check
                                                    type="checkbox"
                                                    label="Micro"
                                                    name="testingReqMicro"
                                                    checked={formData.testingReqMicro}
                                                    onChange={this.handleInputChange}
                                                    style={{ padding: '10px 0 10px 20px' }}
                                                />

                                                <Form.Check
                                                    type="checkbox"
                                                    label="Heavy Metal"
                                                    name="testingReqHeavyMetal"
                                                    checked={formData.testingReqHeavyMetal}
                                                    onChange={this.handleInputChange}
                                                    style={{ padding: '10px 0 10px 20px' }}
                                                />

                                                <Form.Check
                                                    type="checkbox"
                                                    label="Assay"
                                                    name="testingReqAssay"
                                                    checked={formData.testingReqAssay}
                                                    onChange={this.handleInputChange}
                                                    style={{ padding: '10px 0 10px 20px' }}
                                                />
                                            </Form.Group>

                                            <div style={{ marginTop: '20px', padding: '0 20px' }}>
                                                {formData.testInputs.map((testInput, index) => {
                                                    if (testInput.deleted === 1) return null;
                                                    return (
                                                    <div key={index} style={{ display: 'flex', gap: '10px', marginBottom: '10px', alignItems: 'center' }}>
                                                        <Form.Control
                                                            type="text"
                                                            value={testInput.TestName}
                                                            onChange={(e) => {
                                                                const newTestInputs = [...formData.testInputs];
                                                                newTestInputs[index] = {
                                                                    ...newTestInputs[index],
                                                                    TestName: e.target.value
                                                                };
                                                                this.setState(prevState => ({
                                                                    formData: {
                                                                        ...prevState.formData,
                                                                        testInputs: newTestInputs
                                                                    }
                                                                }));
                                                            }}
                                                            style={{ flex: 1 }}
                                                        />
                                                        <i
                                                            className="ti-trash"
                                                            onClick={() => {
                                                                const newTestInputs = [...formData.testInputs];
                                                                newTestInputs[index] = {
                                                                    ...newTestInputs[index],
                                                                    deleted: 1
                                                                };
                                                                this.setState(prevState => ({
                                                                    formData: {
                                                                        ...prevState.formData,
                                                                        testInputs: newTestInputs
                                                                    }
                                                                }));
                                                            }}
                                                            style={{
                                                                cursor: 'pointer',
                                                                color: '#dc2626',
                                                                fontSize: '18px'
                                                            }}
                                                        ></i>
                                                    </div>
                                                    );
                                                })}
                                                <div style={{ display: 'flex', justifyContent: 'center', marginTop: '15px' }}>
                                                    <button
                                                        type="button"
                                                        className="btn btn-sm btn-outline-primary mt-2"
                                                        onClick={() => {
                                                            this.setState(prevState => ({
                                                                formData: {
                                                                    ...prevState.formData,
                                                                    testInputs: [...prevState.formData.testInputs, { RfqTestingId: 0, RfqId: 0, TestName: '', deleted: 0 }]
                                                                }
                                                            }));
                                                        }}
                                                    >
                                                        <i className="ti-plus"></i> Custom Testing Requirement
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </div>

                                {/* Units Requested */}
                                <div className="form-section">
                                    <div
                                        className="section-header"
                                        onClick={() => this.toggleSection('unitsReq')}
                                        style={{ cursor: 'pointer', position: 'relative' }}
                                    >
                                        <h5 style={{ margin: 0, fontSize: '16px', fontWeight: '600' }}>Quantities Requested <i className="fa-solid fa-asterisk" style={{ fontSize: '8px', color: '#dc3545' }}></i></h5>
                                        <span
                                            style={{
                                                position: 'absolute',
                                                right: '24px',
                                                top: '50%',
                                                transform: 'translateY(-50%)',
                                                fontSize: '14px',
                                                color: '#6b7280',
                                                transition: 'transform 0.2s ease'
                                            }}
                                        >
                                            {this.state.expandedSections.unitsReq ? '▼' : '►'}
                                        </span>
                                    </div>
                                    {this.state.expandedSections.unitsReq && (
                                        <div className="section-content">
                                            {errors.tiers && (
                                                <div className="alert alert-danger" role="alert" style={{ padding: '8px 12px', fontSize: '14px', marginBottom: '16px' }}>
                                                    {errors.tiers}
                                                </div>
                                            )}
                                            {formData.tiers.map((tier, index) => (
                                                <div key={index} style={{ marginBottom: '20px' }}>
                                                    <Row className={`align-items-end${tier.deleted === 1 ? ' hide-me' : ''}`}>
                                                        <Col md={5}>
                                                            <Form.Group className="mb-3">
                                                                <Form.Label>Qty {tier.TierNumber} Units {index < 2 ? <i className="fa-solid fa-asterisk" style={{ fontSize: '8px', color: '#dc3545' }}></i> : ''}</Form.Label>
                                                                <Form.Control
                                                                    type="text"
                                                                    placeholder="e.g., 10,000"
                                                                    value={tier.Unit}
                                                                    onChange={(e) => this.handleTierChange(index, 'Unit', e.target.value)}
                                                                    isInvalid={index < 2 && errors.tiers && (!tier.Unit || tier.Unit.trim() === '')}
                                                                />
                                                            </Form.Group>
                                                        </Col>
                                                        <Col md={5}>
                                                            <Form.Group className="mb-3">
                                                                <Form.Label>Qty {tier.TierNumber} Target Price</Form.Label>
                                                                <Form.Control
                                                                    type="text"
                                                                    placeholder="$0.00"
                                                                    value={tier.Price}
                                                                    onChange={(e) => this.handleTierChange(index, 'Price', e.target.value)}
                                                                    isInvalid={false}
                                                                />
                                                            </Form.Group>
                                                        </Col>
                                                        <Col md={2}>
                                                            {index >= 2 && (
                                                                <Form.Group className="mb-3 text-center">
                                                                    <button
                                                                        type="button"
                                                                        style={{ background: 'none', border: 'none', color: '#ef4444', cursor: 'pointer', fontSize: '20px' }}
                                                                        onClick={() => this.handleRemoveTier(index)}
                                                                        title="Delete Qty"
                                                                    >
                                                                        <i className="ti-trash"></i>
                                                                    </button>
                                                                </Form.Group>
                                                            )}
                                                        </Col>
                                                    </Row>
                                                </div>
                                            ))}

                                            <button
                                                type="button"
                                                className="btn btn-sm btn-outline-primary mt-2"
                                                onClick={this.handleAddTier}
                                            >
                                                <i className="ti-plus"></i> Add Qty
                                            </button>
                                        </div>
                                    )}
                                </div>

                                {/* Additional Information */}
                                <div className="form-section">
                                    <div
                                        className="section-header"
                                        onClick={() => this.toggleSection('additionalInfo')}
                                        style={{ cursor: 'pointer', position: 'relative' }}
                                    >
                                        <h5 style={{ margin: 0, fontSize: '16px', fontWeight: '600' }}>Additional Information</h5>
                                        <span
                                            style={{
                                                position: 'absolute',
                                                right: '24px',
                                                top: '50%',
                                                transform: 'translateY(-50%)',
                                                fontSize: '14px',
                                                color: '#6b7280',
                                                transition: 'transform 0.2s ease'
                                            }}
                                        >
                                            {this.state.expandedSections.additionalInfo ? '▼' : '►'}
                                        </span>
                                    </div>
                                    {this.state.expandedSections.additionalInfo && (
                                        <div className="section-content">
                                            <Row>
                                                <Col md={4}>
                                                    <Form.Check
                                                        type="checkbox"
                                                        label="Allergen Free"
                                                        name="allergenFree"
                                                        className="mb-3"
                                                        checked={formData.allergenFree}
                                                        onChange={this.handleInputChange}
                                                    />
                                                </Col>
                                                <Col md={4}>
                                                    <Form.Check
                                                        type="checkbox"
                                                        label="Certified Organic"
                                                        name="certifiedOrganic"
                                                        className="mb-3"
                                                        checked={formData.certifiedOrganic}
                                                        onChange={this.handleInputChange}
                                                    />
                                                </Col>
                                                <Col md={4}>
                                                    <Form.Check
                                                        type="checkbox"
                                                        label="Kitting"
                                                        name="kitting"
                                                        className="mb-3"
                                                        checked={formData.kitting}
                                                        onChange={this.handleInputChange}
                                                    />
                                                </Col>
                                            </Row>
                                            <Form.Group>
                                                <Form.Label>Notes</Form.Label>
                                                <Form.Control
                                                    as="textarea"
                                                    rows={3}
                                                    name="notes"
                                                    placeholder="Enter any additional notes or comments..."
                                                    value={formData.notes}
                                                    onChange={this.handleInputChange}
                                                />
                                            </Form.Group>
                                        </div>
                                    )}
                                </div>

                                {/* Shipping & Payment Terms */}
                                <div className="form-section">
                                    <div
                                        className="section-header"
                                        onClick={() => this.toggleSection('shippingTerms')}
                                        style={{ cursor: 'pointer', position: 'relative' }}
                                    >
                                        <h5 style={{ margin: 0, fontSize: '16px', fontWeight: '600' }}>Shipping & Payment Terms</h5>
                                        <span
                                            style={{
                                                position: 'absolute',
                                                right: '24px',
                                                top: '50%',
                                                transform: 'translateY(-50%)',
                                                fontSize: '14px',
                                                color: '#6b7280',
                                                transition: 'transform 0.2s ease'
                                            }}
                                        >
                                            {this.state.expandedSections.shippingTerms ? '▼' : '►'}
                                        </span>
                                    </div>
                                    {this.state.expandedSections.shippingTerms && (
                                        <div className="section-content">
                                            <Row>
                                                <Col md={6}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label className="d-block">Shipping Method</Form.Label>
                                                        <Form.Select
                                                            name="shippingMethod"
                                                            value={formData.shippingMethod}
                                                            onChange={this.handleInputChange}
                                                        >
                                                            <option>Select shipping method</option>
                                                            {(this.state.dropdownOptions.shipping_method || []).map(opt => (
                                                                <option key={opt.value} value={opt.value}>{opt.label}</option>
                                                            ))}
                                                        </Form.Select>
                                                    </Form.Group>
                                                </Col>
                                                <Col md={6}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Payment Terms</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="paymentTerms"
                                                            placeholder="e.g., 50% DEPOSIT, 50% UPON COMPLETION"
                                                            value={formData.paymentTerms}
                                                            onChange={this.handleInputChange}
                                                        />
                                                    </Form.Group>
                                                </Col>
                                            </Row>
                                        </div>
                                    )}
                                </div>

                                {/* Notes */}
                                <div className="form-section">
                                    <div
                                        className="section-header"
                                        onClick={() => this.toggleSection('notes')}
                                        style={{ cursor: 'pointer', position: 'relative' }}
                                    >
                                        <h5 style={{ margin: 0, fontSize: '16px', fontWeight: '600' }}>Notes</h5>
                                        <span
                                            style={{
                                                position: 'absolute',
                                                right: '24px',
                                                top: '50%',
                                                transform: 'translateY(-50%)',
                                                fontSize: '14px',
                                                color: '#6b7280',
                                                transition: 'transform 0.2s ease'
                                            }}
                                        >
                                            {this.state.expandedSections.notes ? '▼' : '►'}
                                        </span>
                                    </div>
                                    {this.state.expandedSections.notes && (
                                        <div className="section-content">
                                            <NotesSection
                                                notesList={formData.notesList}
                                                currentNote={formData.currentNote}
                                                showAllNotes={this.state.showAllNotes}
                                                onCurrentNoteChange={(e, newValue) => {
                                                    this.setState(prevState => ({
                                                        formData: {
                                                            ...prevState.formData,
                                                            currentNote: newValue
                                                        }
                                                    }));
                                                }}
                                                onAddNote={async () => {
                                                    if (this.state.formData.currentNote.trim()) {
                                                        // If rfqId exists, save directly to database
                                                        if (this.state.rfqId) {
                                                            const success = await this.saveNoteToDatabase(
                                                                this.state.formData.currentNote.trim()
                                                            );

                                                            if (success) {
                                                                // Reload notes to get the saved note with correct username
                                                                await this.loadNotesFromDatabase();

                                                                // Clear current note
                                                                this.setState(prevState => ({
                                                                    formData: {
                                                                        ...prevState.formData,
                                                                        currentNote: ''
                                                                    }
                                                                }));
                                                            }
                                                        } else {
                                                            // No rfqId yet, add to local state (will be saved with main form)
                                                            const selectedRep = this.state.salesReps.find(rep => {
                                                                return rep.id == this.state.formData.salesRep;
                                                            });

                                                            const newNote = {
                                                                RfqNoteId: Date.now(), // Use timestamp as temporary unique ID
                                                                RfqId: 0,
                                                                NoteText: this.state.formData.currentNote.trim(),
                                                                UserId: this.state.formData.salesRep || 0,
                                                                Username: 'Unknown',
                                                                CreatedDateTime: new Date().toISOString(),
                                                                Replies: []
                                                            };

                                                            this.setState(prevState => ({
                                                                formData: {
                                                                    ...prevState.formData,
                                                                    notesList: [...prevState.formData.notesList, newNote],
                                                                    currentNote: ''
                                                                }
                                                            }));
                                                        }
                                                    }
                                                }}
                                                onToggleShowAll={() => this.setState({ showAllNotes: true })}
                                                onAddReply={async (parentNote, replyText) => {
                                                    // If rfqId exists, save directly to database
                                                    if (this.state.rfqId) {
                                                        const success = await this.saveReplyToDatabase(parentNote, replyText);

                                                        if (success) {
                                                            // Small delay to ensure database commit completes
                                                            await new Promise(resolve => setTimeout(resolve, 300));

                                                            // Reload notes to get the saved reply with correct username
                                                            await this.loadNotesFromDatabase();
                                                        }
                                                    } else {
                                                        // No rfqId yet, add to local state (will be saved with main form)
                                                        const selectedRep = this.state.salesReps.find(rep => {
                                                            return rep.id == this.state.formData.salesRep;
                                                        });

                                                        const newReply = {
                                                            RfqNoteReplyId: Date.now(),
                                                            RfqNoteId: parentNote.RfqNoteId,
                                                            NoteText: replyText,
                                                            UserId: this.state.formData.salesRep || 0,
                                                            Username: selectedRep ? `${selectedRep.firstname} ${selectedRep.lastname}` : 'Unknown',
                                                            CreatedDateTime: new Date().toISOString()
                                                        };

                                                        this.setState(prevState => ({
                                                            formData: {
                                                                ...prevState.formData,
                                                                notesList: prevState.formData.notesList.map(note =>
                                                                    note.RfqNoteId === parentNote.RfqNoteId
                                                                        ? {
                                                                            ...note,
                                                                            Replies: [...(note.Replies || []), newReply]
                                                                        }
                                                                        : note
                                                                )
                                                            }
                                                        }));
                                                    }
                                                }}
                                            />
                                        </div>
                                    )}
                                </div>

                                {/* Action Buttons */}
                                {(this.state.historyId === null || this.state.historyId === undefined) && (

                                    <div className="d-flex justify-content-end mb-5" style={{ gap: '20px' }}>
                                        <Button
                                            variant="outline-secondary"
                                            onClick={this.handleSaveDraft}
                                            disabled={savingDraft || loading}
                                        >
                                            {savingDraft ? 'Saving...' : 'Save Draft'}
                                        </Button>
                                        <Button
                                            type="submit"
                                            variant="primary"
                                            disabled={loading || savingDraft}
                                        >
                                            {loading ? 'Submitting...' : 'Submit To Formula'}
                                        </Button>
                                    </div>
                                )}

                            </Form>
                        </div>
                    </section>
                </div>

                {/* AI Extraction Results Modal */}
                <Modal
                    show={this.state.showAIExtractionModal}
                    onHide={this.closeAIExtractionModal}
                    size="xl"
                    centered
                >
                    <Modal.Header closeButton>
                        <Modal.Title>AI Extracted Ingredients</Modal.Title>
                    </Modal.Header>
                    <Modal.Body style={{ maxHeight: '70vh', overflowY: 'auto' }}>
                        <div className="mb-3">
                            <div className="d-flex justify-content-between align-items-center mb-3">
                                <div>
                                    <strong>{this.state.selectedIngredients.length}</strong> of {this.state.extractedIngredients.length} ingredients selected
                                </div>
                                <div>
                                    <Button
                                        variant="outline-primary"
                                        size="sm"
                                        onClick={this.selectAllIngredients}
                                        className="me-2"
                                    >
                                        Select All
                                    </Button>
                                    <Button
                                        variant="outline-secondary"
                                        size="sm"
                                        onClick={this.deselectAllIngredients}
                                    >
                                        Deselect All
                                    </Button>
                                </div>
                            </div>

                            {this.state.extractedIngredients.length === 0 ? (
                                <div className="text-center py-4">
                                    <p className="text-muted">No ingredients extracted</p>
                                </div>
                            ) : (
                                <div style={{ border: '1px solid #e5e7eb', borderRadius: '8px' }}>
                                    <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                                        <thead style={{ background: '#f8f9fa' }}>
                                            <tr>
                                                <th style={{ padding: '12px', textAlign: 'center', width: '50px', borderBottom: '1px solid #e5e7eb' }}>
                                                    <Form.Check
                                                        type="checkbox"
                                                        checked={this.state.selectedIngredients.length === this.state.extractedIngredients.length}
                                                        onChange={() => {
                                                            if (this.state.selectedIngredients.length === this.state.extractedIngredients.length) {
                                                                this.deselectAllIngredients();
                                                            } else {
                                                                this.selectAllIngredients();
                                                            }
                                                        }}
                                                    />
                                                </th>
                                                <th style={{ padding: '12px', fontWeight: '600', color: '#374151', borderBottom: '1px solid #e5e7eb' }}>Ingredient Name</th>
                                                <th style={{ padding: '12px', fontWeight: '600', color: '#374151', borderBottom: '1px solid #e5e7eb' }}>Part Name</th>
                                                <th style={{ padding: '12px', fontWeight: '600', color: '#374151', borderBottom: '1px solid #e5e7eb' }}>Amount</th>
                                                <th style={{ padding: '12px', fontWeight: '600', color: '#374151', borderBottom: '1px solid #e5e7eb' }}>Unit</th>
                                                <th style={{ padding: '12px', fontWeight: '600', color: '#374151', borderBottom: '1px solid #e5e7eb' }}>Daily Value</th>
                                                <th style={{ padding: '12px', fontWeight: '600', color: '#374151', borderBottom: '1px solid #e5e7eb', textAlign: 'center' }}>Status</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.state.extractedIngredients.map((ingredient, index) => (
                                                <tr key={ingredient.id} style={{ borderBottom: index < this.state.extractedIngredients.length - 1 ? '1px solid #f3f4f6' : 'none' }}>
                                                    <td style={{ padding: '12px', textAlign: 'center' }}>
                                                        <Form.Check
                                                            type="checkbox"
                                                            checked={ingredient.selected || false}
                                                            onChange={() => this.toggleIngredientSelection(ingredient.id)}
                                                        />
                                                    </td>
                                                    <td style={{ padding: '12px', color: '#374151' }}>
                                                        {ingredient.matched ? (
                                                            <div>
                                                                <div>{ingredient.name}</div>
                                                                <small className="text-success">→ {ingredient.matchedName}</small>
                                                            </div>
                                                        ) : (
                                                            ingredient.name
                                                        )}
                                                    </td>
                                                    <td style={{ padding: '12px', position: 'relative' }}>
                                                        <div style={{ position: 'relative' }}>
                                                            <Form.Control
                                                                size="sm"
                                                                type="text"
                                                                placeholder="Search Part ID..."
                                                                value={(() => {
                                                                    // Show search term if dropdown is open, otherwise show selected value
                                                                    if (this.state.partIdDropdownOpen[ingredient.id]) {
                                                                        return this.state.partIdSearchTerms[ingredient.id] || '';
                                                                    } else if (ingredient.partId) {
                                                                        const selectedPart = this.state.ingredientParts.find(p => p.id === ingredient.partId);
                                                                        return selectedPart ? `${selectedPart.id} - ${selectedPart.name}` : '';
                                                                    }
                                                                    return '';
                                                                })()}
                                                                onChange={(e) => this.handlePartIdSearch(ingredient.id, e.target.value)}
                                                                onFocus={() => this.togglePartIdDropdown(ingredient.id, true)}
                                                                onBlur={() => setTimeout(() => this.togglePartIdDropdown(ingredient.id, false), 200)}
                                                                style={{
                                                                    borderColor: !ingredient.partId ? '#ef4444' : '#d1d5db',
                                                                    minWidth: '180px'
                                                                }}
                                                            />
                                                            {this.state.partIdDropdownOpen[ingredient.id] && (
                                                                <div
                                                                    style={{
                                                                        position: 'absolute',
                                                                        top: '100%',
                                                                        left: 0,
                                                                        right: 0,
                                                                        maxHeight: '200px',
                                                                        overflowY: 'auto',
                                                                        overflowX: 'hidden',
                                                                        backgroundColor: 'white',
                                                                        border: '1px solid #d1d5db',
                                                                        borderRadius: '4px',
                                                                        marginTop: '2px',
                                                                        zIndex: 99999999,
                                                                        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
                                                                    }}
                                                                    onMouseDown={(e) => e.preventDefault()} // Prevent blur on click
                                                                >
                                                                    <div
                                                                        style={{
                                                                            padding: '8px',
                                                                            cursor: 'pointer',
                                                                            borderBottom: '1px solid #e5e7eb',
                                                                            fontSize: '12px',
                                                                            color: '#6b7280'
                                                                        }}
                                                                        onClick={() => {
                                                                            this.updateExtractedIngredient(ingredient.id, 'partId', '');
                                                                            this.togglePartIdDropdown(ingredient.id, false);
                                                                        }}
                                                                    >
                                                                        Clear selection
                                                                    </div>
                                                                    {this.getFilteredParts(ingredient.id).length > 0 ? (
                                                                        this.getFilteredParts(ingredient.id).map(part => (
                                                                            <div
                                                                                key={part.id}
                                                                                style={{
                                                                                    padding: '8px',
                                                                                    cursor: 'pointer',
                                                                                    backgroundColor: ingredient.partId === part.id ? '#f3f4f6' : 'transparent',
                                                                                    fontSize: '13px'
                                                                                }}
                                                                                onMouseEnter={(e) => e.target.style.backgroundColor = '#f3f4f6'}
                                                                                onMouseLeave={(e) => e.target.style.backgroundColor = ingredient.partId === part.id ? '#f3f4f6' : 'transparent'}
                                                                                onClick={() => {
                                                                                    this.updateExtractedIngredient(ingredient.id, 'partId', part.id);
                                                                                }}
                                                                            >
                                                                                <strong>{part.id}</strong> - {part.name}
                                                                            </div>
                                                                        ))
                                                                    ) : (
                                                                        <div style={{ padding: '8px', color: '#9ca3af', fontSize: '13px' }}>
                                                                            No matches found
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            )}
                                                        </div>
                                                    </td>
                                                    <td style={{ padding: '12px' }}>
                                                        <Form.Control
                                                            type="text"
                                                            size="sm"
                                                            value={ingredient.amount}
                                                            onChange={(e) => this.updateExtractedIngredient(ingredient.id, 'amount', e.target.value)}
                                                            style={{ width: '80px' }}
                                                        />
                                                    </td>
                                                    <td style={{ padding: '12px' }}>
                                                        <Form.Select
                                                            size="sm"
                                                            value={ingredient.unit || ''}
                                                            onChange={(e) => this.updateExtractedIngredient(ingredient.id, 'unit', e.target.value)}
                                                            style={{ width: '120px' }}
                                                        >
                                                            <option value="">Select unit</option>
                                                            <option value="g">g</option>
                                                            <option value="mg">mg</option>
                                                            <option value="mcg">mcg</option>
                                                            <option value="IU">IU</option>
                                                            <option value="CFU">CFU</option> 
                                                        </Form.Select>
                                                    </td>
                                                    <td style={{ padding: '12px' }}>
                                                        <Form.Control
                                                            type="text"
                                                            size="sm"
                                                            value={ingredient.dailyValue || ''}
                                                            onChange={(e) => this.updateExtractedIngredient(ingredient.id, 'dailyValue', e.target.value)}
                                                            placeholder="e.g. 100%"
                                                            style={{ width: '90px' }}
                                                        />
                                                    </td>
                                                    <td style={{ padding: '12px', textAlign: 'center' }}>
                                                        {ingredient.matched ? (
                                                            
                                                            <i className='ti-check' style={{
                                                                color: '#10b981',
                
                                                                fontSize: '22px',
                                                                fontWeight: '500'
                                                            }}>
                                                               
                                                            </i>
                                                        ) : (

                                                            <i className='ti-alert' title={'No Match Found, Please match manually'} style={{
                                                                color: '#ef4444',
                
                                                                fontSize: '22px',
                                                                fontWeight: '500'
                                                            }}>
                                                               
                                                            </i>
                                                        )}
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            )}
                        </div>

                        <div className="alert alert-info" role="alert">
                            <strong>Note:</strong> All selected ingredients will be imported. Ingredients without Part IDs can be manually matched later in the ingredients table.
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={this.closeAIExtractionModal}>
                            Cancel
                        </Button>
                        <Button
                            variant="primary"
                            onClick={this.importSelectedIngredients}
                            disabled={this.state.selectedIngredients.length === 0}
                        >
                            Import Selected ({this.state.selectedIngredients.length})
                        </Button>
                    </Modal.Footer>
                </Modal>

                {/* Delete Ingredient Confirmation Modal */}
                <Modal show={this.state.showDeleteModal} onHide={this.cancelDeleteIngredient} centered>
                    <Modal.Header closeButton>
                        <Modal.Title>Confirm Delete</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <p>Are you sure you want to delete the ingredient:</p>
                        <p><strong>"{this.state.deleteIngredientName}"</strong></p>
                        <p className="text-muted">This action cannot be undone.</p>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={this.cancelDeleteIngredient}>
                            Cancel
                        </Button>
                        <Button variant="danger" onClick={this.confirmDeleteIngredient}>
                            Delete Ingredient
                        </Button>
                    </Modal.Footer>
                </Modal>

                {this.state.rfqId && (
                    <AuditLogSection entityType="rfq" entityId={this.state.rfqId} />
                )}
            </Layout>
        );
    }
}

export default AddNewRFQ;